
import { Popup } from "../components";


let a11yValidateErrorTimerArr = [];

/**
 * @summary Validateion Error 문구의 노출을 관리하는 함수 
 * 실시간으로 읽어주기위한 #a11y-notify 영역에 role="alert" 속성추가하고 낭독할 error나 waring 문구를 추가
 * 에러가 여러개 노출될때 필요한 error만 낭독하도록 처리
 * @description [관련지침]   스크린리더 사용자에게 즉시 인지해야하는 정보를 동등하게 제공 
 */
export function a11yValidateError() {
   
    const errorMessages = $('.ui-input.error')
        .map((_idx, obj) => $(obj).find('.message').text())
        .toArray()  // text추출
        .filter((_obj, idx) => idx === 0)    // 일단 첫번째 요소만 보여줌
        .map((text) => `<span>${text}</span>`);

    // validation을 보여줄 요소가 없다면
    if ($('#a11y-notify').length <= 0) {
        $('#wrap-mmk').append(`<div id="a11y-notify" class="hide-txt" role="alert" style="display:none;"></div>`);
    }

    const $A11yNotify = $('#a11y-notify');
    // 1번 호출후 사라지기전에 재호출 할경우와 10초후 사라질경우
    const clearTimer = () => {
        a11yValidateErrorTimerArr.forEach((_timerId, index) => {
            clearTimeout(_timerId);
            // 여러번 호출했을때 처리를 하기 위해 배열로
            a11yValidateErrorTimerArr.splice(index, 1);
        });
    };
    const showMessage = () => {
        $A11yNotify.html(errorMessages).show();

        clearTimer();
        const timerId = setTimeout(() => {
            $A11yNotify.empty().hide();
            clearTimer();
        }, 10000);
        a11yValidateErrorTimerArr.push(timerId);
    };

    const isVisible = $A11yNotify.is(':visible');
    $A11yNotify.hide();
    // 재호출시(요소가 보여지고 있을시 0.3초간 없앴다가 보여준다.
    setTimeout(showMessage, isVisible && 300);
}

/**
 * @summary 특정 노드의 이웃 노드들을 모두 aria-hidden:true 처리(유틸함수)
 * @param $content { HTMLElement | selector }
 * @param isVisible {boolean} 기본: true
 */ 
export function a11yHideOtherContent($content, isVisible=true){
    $content.siblings().attr('aria-hidden', isVisible);
}

/**
 * @summary 특정 노드의 이웃 노드들의 aria-hidden 을 모두 제거(유틸함수)
 * @param $content {HTMLElement | selector }
 */ 
export function a11yShowOtherContent($content){
    $content.siblings().removeAttr('aria-hidden');
}

/**
 * @summary html 태그에 a11y 클래스 존재여부 체크(퍼블 테스트용으로 사용하였음 - 현재 미사용)
 * 테스트용 
 * @returns {boolean}
 */ 
export function isA11y(){
    return $('html').hasClass('a11y');
}

/**
 * @summary 스크린리더 활성화여부 체크 로직 - 
 * 일반 사용자의 사용성을 높이기 위해, 팝업 오픈시 특정 영역이나 입력박스로 강제로 초점을 보내는 스크립트와 
 * 접근성에서 팝업이나 화면 이동시 header영역으로 초점 이동시키는 로직의 충돌을 막기위해 스크린리더 활성화여부에 따라
 * 접근성 로직을 분기처리 함 (작동 안함)
 * @param data  {boolean}
 * @returns data {JSON} Native API 
 */ 
export function _isCheckCallisvocieover(data){

    window['_isCheckCallisvocieover'] = data;

    return data;
}

/**
 * @summary 스크린리더 활성화여부 체크 로직 (작동 안함)
 * @param data  {boolean}
 */ 
export function _isVoiceOverCheck(){
    $(document).ready(function(){
        if (typeof MobileCallUtils !== 'undefined') {

            MobileCallUtils.common.callisvoiceover('_isCheckCallisvocieover');
        }
    });
}

/**
 * @summary body class a11y 적용전에 로직이 돌아서 제대로 체크 못하는 현상 수정
 * TODO - 퍼블에서만 사용 추후 삭제 필요
 * @param func callback함수로 a11y체크
 * @returns {boolean}
 */ 
export function isA11yCheckVersion(){

    const isCheckVoiceOver = localStorage.getItem("voiceoverYn") === 'Y'; //스크린리더 체크 여부

    // 172 일때
    if (location.href.match('172.')){
        if(!location.href.match('a11y')) return false;
        if(location.href.match('a11y-off')) return false;
        if(location.href.match('a11y-on')) return true;
    }

    // 로컬 일때
    if (location.href.match('127.') || location.href.match('localhost.')){
        if(!location.href.match('a11y')) return true;
        if(location.href.match('a11y-off')) return false;
        if(location.href.match('a11y-on')) return true;
    }
    
    if($('html')?.hasClass('pc') || $('html')?.hasClass('pc_m')){ //pc면서 a11y있을시
        return true;
    }else{
        return isCheckVoiceOver; //모바일이면서 스크린리더 체크
    }
}

/**
 * @summary 선택자 속성 및 값 지정(유틸함수)
 * @param $content 선택자
 * @param type setAttribute 속성
 * @param option 값 지정
 */
export function isA11ySetAttr($content, type="tabindex", option="0"){
    $content?.forEach((list) => {
        if (list.closest('[data-type]')?.length > 0) { // CHPFMTASK-1714 추가
            if(list.closest('[data-type]').getAttribute('data-type') != 'select-bank') { 
                list.setAttribute(type, option);
            }
        }
        
        //list.setAttribute(type, option);
    });
}

/**
 * @summary 선택자 속성 및 값 지정(유틸함수)
 * @param $content 선택자
 * @param type removeAttribute 속성
 */
export function isA11yRemoveAttr($content, type="tabindex"){

    $content?.forEach((list) => {
        list.removeAttribute(type);
    });
}

/**
 * @summary 접근성 관련 속성의 제거를 위한 공통함수(유틸함수)
 * @param $content 선택자
 * @param cls 클래스명
 */
export function isA11yRemoveClass($content, cls="",){
    
    $content.forEach((list) => {
        list.classList.remove(cls);
    });
}

/** 
 * @summary 위젯, 팝업 셀렉트 focus 이동 및 hidetext 접근성 대응
 * @description [관련지침]   
 * 1) 숨겨진 콘텐츠 및 의미없는 개체에 초점이 이동하면 안됨.
 * 2) 페이지 팝업 전환 후 의미를 이해할 수 있는 header 영역을 낭독할 수 있도록 초점 이동
 * @param $content 선택자
 * @async 
*/
export async function isA11ySlideFocusMove($content=document, time=500){
    
    try {
        // IOS TEST
        const isScrollCheck = $('.page-inner-scroll');

        $('.popup-wrap').removeAttr('aria-hidden');
        $('.a11y').attr('style','');
        $('.kbank-page-wrapper').removeAttr('aria-hidden');

        if(!!isScrollCheck?.length){
            const config = {
                attributes: true,
                attributeOldValue: true,
                attributeFilter: ['style'],
            };

            const observer = new MutationObserver(async (mutation, observer) => {
                const { target } = mutation[0];

                const timer = new Promise((resolve) => setTimeout(resolve, time));

                await timer;
                
                const isCheckHidden = target.style.overflow === 'hidden';
                const isCheckAriaHidden = $('.kbank-page-wrapper').attr('aria-hidden');
                const isCheckBodyOverflow = document.querySelector('body').style.overflow === 'hidden';

                if((isCheckHidden || isCheckAriaHidden || isCheckBodyOverflow)) return;

                let isFocusEles = $content?.querySelectorAll('.header-content a,.header-content  button:not(.close-btn),.header-content  input, textarea,.header-content  select');
                let topHeaderTitle = $content?.querySelector('.header-content .tit-head > *:first-child:not(.hide-txt)') || $content?.querySelector('.header-content  .tit-header > *:first-child:not(.hide-txt)');
                let headerTitle = $content?.querySelector('.header-content .title-field-popup:not(strong)');
                let prodnameTitle = $content?.querySelector('.header-content .prodname-tit-field');
                let leftTitle = $content?.querySelector('.header-content .home-tit') || $content?.querySelector('.tit-head');
                let divTitle = $content?.querySelector('.header-content .title-field-popup:not(strong)');
                let focusNum = 0;

                if(divTitle){
                    divTitle.setAttribute('aria-hidden','false');
                    divTitle.setAttribute('tabindex','0');
                }

                if(leftTitle){
                    leftTitle.setAttribute('aria-hidden','false');
                    leftTitle.setAttribute('tabindex','0');
                }

                if(topHeaderTitle){
                    topHeaderTitle.setAttribute('aria-hidden','false');
                    topHeaderTitle.setAttribute('tabindex','0');
                    
                }
                
                if(headerTitle){
                    headerTitle.setAttribute('aria-hidden','false');
                    headerTitle.setAttribute('tabindex','0');
                }

                if(prodnameTitle){
                    prodnameTitle.setAttribute('aria-hidden','false');
                    prodnameTitle.setAttribute('tabindex','0');
                }
                
                if(isFocusEles){
                    isFocusEles = Array.from([divTitle, leftTitle, topHeaderTitle, headerTitle, prodnameTitle, ...isFocusEles])?.filter((list) => {
                        const isCheckHide = list?.querySelector('i');
                        const isCheckBackBtn = list?.classList.contains('btn-back');

                        if(!isCheckHide && isCheckBackBtn){
                            list.setAttribute('aria-hidden','true');
                        }else{
                            return list
                        }
                    });

                    if(!isFocusEles?.length) return; //여러 혼합 형태 팝업일시 focus잃어서 팝업닫기로 focus되는현상 수정

                    
                    const isTagName = isFocusEles[focusNum].tagName !== 'INPUT' || isFocusEles[focusNum].tagName !== 'SPAN';
                    
                    
                    //TODO - ios focus 초점 버그 해결 필요
                    isTagName && isFocusEles[focusNum]?.setAttribute('tabindex', '0');
                    isTagName && isFocusEles[focusNum]?.setAttribute('aria-hidden', 'false');

                    
                    const delay2 = new Promise((resolve) => setTimeout(resolve, 600));

                    await delay2;
                    isFocusEles[focusNum]?.focus();

                    const backBtnEles =  Array.from(document.querySelectorAll('a'))?.filter((item) => {
                        if(item.role !== 'tab') return item;
                    });

                    backBtnEles?.length && Array.from(backBtnEles).forEach((list) => list.setAttribute('role', 'button'));
                    
                    observer.disconnect();
                }   
            });

            observer.observe(isScrollCheck[0], config);
        }else{
            //스크롤 영역 없을시
            const timer = new Promise((resolve) => setTimeout(resolve, time));

            await timer;
            let isFocusEles = $content?.querySelectorAll('a, button:not(.close-btn), input, textarea, select');
            let topHeaderTitle = $content?.querySelector('.tit-head > *:first-child:not(.hide-txt)') || $content?.querySelector('.tit-header > *:first-child:not(.hide-txt)');
            let headerTitle = $content?.querySelector('.title-field-popup:not(strong)');
            let prodnameTitle = $content?.querySelector('.prodname-tit-field');
            let leftTitle = $content?.querySelector('.home-tit') || $content?.querySelector('.tit-head');;
            let divTitle = $content?.querySelector('.title-field-popup:not(strong)');
            let focusNum = 0;
            

            const isCheckAriaHidden = $('.kbank-page-wrapper').attr('aria-hidden');
            const isCheckBodyOverflow = document.querySelector('body').style.overflow === 'hidden';

            if(isCheckAriaHidden || isCheckBodyOverflow) return;

            if(divTitle){
                divTitle.setAttribute('aria-hidden','false');
                divTitle.setAttribute('tabindex','0');
            }

            if(leftTitle){
                leftTitle.setAttribute('aria-hidden','false');
                leftTitle.setAttribute('tabindex','0');
            }

            if(topHeaderTitle){
                topHeaderTitle.setAttribute('aria-hidden','false');
                topHeaderTitle.setAttribute('tabindex','0');
            }
            
            if(headerTitle){
                headerTitle.setAttribute('aria-hidden','false');
                headerTitle.setAttribute('tabindex','0');
            }

            if(prodnameTitle){
                prodnameTitle.setAttribute('aria-hidden','false');
                prodnameTitle.setAttribute('tabindex','0');
            }
            
            if(isFocusEles){
                isFocusEles = Array.from([divTitle, leftTitle, topHeaderTitle, headerTitle, prodnameTitle, ...isFocusEles])?.filter((list) => {
                    const isCheckHide = list?.querySelector('i');
                    const isCheckBackBtn = list?.classList.contains('btn-back');

                    if(!isCheckHide && isCheckBackBtn){
                        list.setAttribute('aria-hidden','true');
                    }else{
                        return list
                    }
                });

                if(!isFocusEles?.length) return; //여러 혼합 형태 팝업일시 focus잃어서 팝업닫기로 focus되는현상 수정

                const delay = new Promise((resolve) => setTimeout(resolve, 500));

                await delay;

                const isTagName = isFocusEles[focusNum].tagName !== 'INPUT' || isFocusEles[focusNum].tagName !== 'SPAN';

                
                //TODO - ios focus 초점 버그 해결 필요
                isTagName && isFocusEles[focusNum]?.setAttribute('tabindex', '0');
                isTagName && isFocusEles[focusNum]?.setAttribute('aria-hidden', 'false');
                

                const delay2 = new Promise((resolve) => setTimeout(resolve, 500));

                await delay2;
                isFocusEles[focusNum]?.focus();

                const backBtnEles =  Array.from(document.querySelectorAll('a'))?.filter((item) => {
                    if(item.role !== 'tab') return item;
                });

                backBtnEles?.length && Array.from(backBtnEles).forEach((list) => list.setAttribute('role', 'button'));
            }   
        }
    } catch (error) {
        throw new Error(error);
    }
}

/** 
 * @summary 위젯, 팝업 셀렉트 focus이동 및 hidetext - close 시 접근성 수정
 * @description [관련지침]   
 * 1) 숨겨진 콘텐츠 및 의미없는 개체에 초점이 이동해서는 안됨
 * 2) 페이지 팝업 전환 후 의미를 이해할 수 있는 header 영역을 낭독할 수 있도록 초점 이동
 * @param $content 선택자
 * @async
*/
export async function isA11yCloseSlideFocusMove($content=document, time=500){
    

    try {
        // IOS TEST
        const isScrollCheck = $('.page-inner-scroll');

        $('.popup-wrap').removeAttr('aria-hidden');
        $('.a11y').attr('style','');
        $('.kbank-page-wrapper').removeAttr('aria-hidden');

        if(!!isScrollCheck?.length){
            const config = {
                attributes: true,
                attributeOldValue: true,
                attributeFilter: ['style'],
            };

            const observer = new MutationObserver(async (mutation, observer) => {
                const { target } = mutation[0];

                const timer = new Promise((resolve) => setTimeout(resolve, time));

                await timer;

                let isFocusEles = $content?.querySelectorAll('a, button:not(.close-btn), input, textarea, select');
                let topHeaderTitle = $content?.querySelector('.tit-head > *:first-child:not(.hide-txt)') || $content?.querySelector('.tit-header > *:first-child:not(.hide-txt)');
                let headerTitle = $content?.querySelector('.title-field-popup:not(strong)');
                let prodnameTitle = $content?.querySelector('.prodname-tit-field');
                let leftTitle = $content?.querySelector('.home-tit');
                let focusNum = 0;

                if(leftTitle){
                    leftTitle.setAttribute('aria-hidden','false');
                    leftTitle.setAttribute('tabindex','0');
                }

                if(topHeaderTitle){
                    topHeaderTitle.setAttribute('aria-hidden','false');
                    topHeaderTitle.setAttribute('tabindex','0');
                }
                
                if(headerTitle){
                    headerTitle.setAttribute('aria-hidden','false');
                    headerTitle.setAttribute('tabindex','0');
                }

                if(prodnameTitle){
                    prodnameTitle.setAttribute('aria-hidden','false');
                    prodnameTitle.setAttribute('tabindex','0');
                }
                
                if(isFocusEles){
                    isFocusEles = Array.from([leftTitle, topHeaderTitle, headerTitle, prodnameTitle, ...isFocusEles])?.filter((list) => {
                        const isCheckHide = list?.querySelector('i');
                        const isCheckBackBtn = list?.classList.contains('btn-back');

                        if(!isCheckHide && isCheckBackBtn){
                            list.setAttribute('aria-hidden','true');
                        }else{
                            return list
                        }
                    });

                    if(!isFocusEles?.length) return; //여러 혼합 형태 팝업일시 focus잃어서 팝업닫기로 focus되는현상 수정

                    const isTagName = isFocusEles[focusNum].tagName !== 'INPUT' || isFocusEles[focusNum].tagName !== 'SPAN';
                    
                    if(!prodnameTitle && !headerTitle && !leftTitle){
                        isTagName && isFocusEles[focusNum]?.setAttribute('role', 'button');
                    }
                    
                    //TODO - ios focus 초점 버그 해결 필요
                    isTagName && isFocusEles[focusNum]?.setAttribute('tabindex', '0');
                    isTagName && isFocusEles[focusNum]?.setAttribute('aria-hidden', 'false');

                    $('*').blur();
                    
                    const delay2 = new Promise((resolve) => setTimeout(resolve, 600));

                    await delay2;
                    isFocusEles[focusNum]?.focus();

                    const backBtnEles =  Array.from(document.querySelectorAll('a'))?.filter((item) => {
                        if(item.role !== 'tab') return item;
                    });

                    backBtnEles?.length && Array.from(backBtnEles).forEach((list) => list.setAttribute('role', 'button'));
                    
                    observer.disconnect();
                }   
            });

            observer.observe(isScrollCheck[0], config);
        }else{
            //스크롤 영역 없을시
            const timer = new Promise((resolve) => setTimeout(resolve, time));

            await timer;
            let isFocusEles = $content?.querySelectorAll('a, button:not(.close-btn), input, textarea, select');
            let topHeaderTitle = $content?.querySelector('.tit-head > *:first-child:not(.hide-txt)') || $content?.querySelector('.tit-header > *:first-child:not(.hide-txt)');
            let headerTitle = $content?.querySelector('.title-field-popup:not(strong)');
            let prodnameTitle = $content?.querySelector('.prodname-tit-field');
            let leftTitle = $content?.querySelector('.home-tit');
            let focusNum = 0;

            const isCheckAriaHidden = $('.kbank-page-wrapper').attr('aria-hidden');
            const isCheckBodyOverflow = document.querySelector('body').style.overflow === 'hidden';

            if(isCheckAriaHidden || isCheckBodyOverflow) return;

            if(leftTitle){
                leftTitle.setAttribute('aria-hidden','false');
                leftTitle.setAttribute('tabindex','0');
            }

            if(topHeaderTitle){
                topHeaderTitle.setAttribute('aria-hidden','false');
                topHeaderTitle.setAttribute('tabindex','0');
            }
            
            if(headerTitle){
                headerTitle.setAttribute('aria-hidden','false');
                headerTitle.setAttribute('tabindex','0');
            }

            if(prodnameTitle){
                prodnameTitle.setAttribute('aria-hidden','false');
                prodnameTitle.setAttribute('tabindex','0');
            }
            
            if(isFocusEles){
                isFocusEles = Array.from([leftTitle, topHeaderTitle, headerTitle, prodnameTitle, ...isFocusEles])?.filter((list) => {
                    const isCheckHide = list?.querySelector('i');
                    const isCheckBackBtn = list?.classList.contains('btn-back');

                    if(!isCheckHide && isCheckBackBtn){
                        list.setAttribute('aria-hidden','true');
                    }else{
                        return list
                    }
                });

                if(!isFocusEles?.length) return; //여러 혼합 형태 팝업일시 focus잃어서 팝업닫기로 focus되는현상 수정

                const delay = new Promise((resolve) => setTimeout(resolve, 500));

                await delay;

                const isTagName = isFocusEles[focusNum].tagName !== 'INPUT' || isFocusEles[focusNum].tagName !== 'SPAN';;

                if(!prodnameTitle && !headerTitle && !leftTitle){
                    isTagName && isFocusEles[focusNum]?.setAttribute('role', 'button');
                }
                
                //TODO - ios focus 초점 버그 해결 필요
                isTagName && isFocusEles[focusNum]?.setAttribute('tabindex', '0');
                isTagName && isFocusEles[focusNum]?.setAttribute('aria-hidden', 'false');
                

                const delay2 = new Promise((resolve) => setTimeout(resolve, 500));

                await delay2;
                isFocusEles[focusNum]?.focus();

                const backBtnEles =  Array.from(document.querySelectorAll('a'))?.filter((item) => {
                    if(item.role !== 'tab') return item;
                });

                backBtnEles?.length && Array.from(backBtnEles).forEach((list) => list.setAttribute('role', 'button'));
            }   
        }
    } catch (error) {
        throw new Error(error);
    }
}
/** 
 * @summary @deprecated
 * @param fnc 실행 함수
 * @param errname 에러 name
*/
export function isA11yTryCatch(fnc, errName){
    
    try {
        if(typeof fnc === 'function'){
            fnc();
        }
    } catch (error) {
        throw new Error(`${errName}_${error}`);
    }
}

/**
 * @summary datespinner의 존재여부를 확인(유틸함수)
 * @param elements 선택자들 [NodeList]
 * @returns boolean
 */
export function isA11yDateSpinner(elements = []){
    

    if(!elements?.length) return;

    
}

/** 
 * @summary @deprecated
 */
export function isA11yScrollBarAccess($el, config={
    childList: false,
    subtree: true,
    attributeOldValue: false,
}){
    try {
        const observer = new MutationObserver((mutation, observer) => {
            const { target } = mutation[0];
            const {clientHeight, scrollHeight} = target;

            if(scrollHeight >= clientHeight){
                target.setAttribute('tabindex','0');
            }

            observer.disconnect();
        });

        observer.observe($el, config);
    } catch (error) {
        throw new Error(`isA11yScrollBarAccess_${error}`)
    }
}

/**
 * @summary 스크린리더기에서 로딩중입니다,로딩이 완료되었습니다 적용 함수
 * @description [관련지침]   적절한 대체텍스트의 제공
 * @param $el 실행되는 스캘레톤 wrap {String} start | complete : 시작, 완료 두종류 타입
 * @async 
 */
export async function isA11yFakeSkeleton($el){
    

    let isType = 'start';

    const textEleBox = $el[0].querySelector('.hide-txt');

    const delay = new Promise((resolve) => setTimeout(resolve, 200));
    
    await delay;

    if(isType === 'start'){
        await (textEleBox.innerText = '로딩 중입니다.');
    }
}

/**
 * @summary 팝업 닫기버튼 생성 함수
 * 
 */
export function isA11yCreatButton(){
    //팝업 닫기버튼 생성 함수
    const closeBtn = document.createElement('button');

    closeBtn.setAttribute('role','button');
    closeBtn.setAttribute('title','팝업 닫기');

    closeBtn.style.position = 'fixed';
    closeBtn.style.top = '0';
    closeBtn.style.left = '0';
    closeBtn.style.zIndex = '-999';
    closeBtn.style.width = '100%';
    closeBtn.style.height = '100%';
    
    closeBtn.classList.add('close-btn');

    return closeBtn;
}

/**
 * @summary 스피너 aria-live영역 1개만 생성되게 하는 로직
 * 
 */
export function isA11yOnceSpinnerDiv(){
    setTimeout(() => {
        const selectDivEles = document.querySelectorAll('.spinner-live');
        selectDivEles.forEach((list,idx) => {
            if(idx > 0){
                list.remove();
            }
        });
    },500)
}

/**
 * @summary 키패드 접근성, 벨리데이션 텍스트 및 현재 인풋입력 텍스트 읽어주는 함수
 * @description [관련지침]   적절한 대체텍스트의 제공
 */
export function isA11yKeyPad(){
    //
    try {
        const keypadBtnEles = document.querySelectorAll('.component-keypad-popup .keypad-btn, .component-keypad-popup button[type="button"], .ui-webnumpad .keypad-btn, .ui-webnumpad button[type="button"]');
        keypadBtnEles && isA11yRemoveAttr(keypadBtnEles,'aria-hidden');
        /* placeHolder값 테이블 캡션에 넣기 주석
        const keypadPlaceHolderEles = document.querySelectorAll('.component-keypad-popup .keypad-value .placeholder, .ui-webnumpad .keypad-value .placeholder');
        const keypadCaptionEles = document.querySelectorAll('.component-keypad-popup .keypad-table caption, .ui-webnumpad .keypad-table caption');

        keypadCaptionEles?.forEach((list, idx) => {
            if(!keypadPlaceHolderEles[idx]) return;

            list.textContent = `${keypadPlaceHolderEles[idx].textContent} 키패드`;
        });
        */

        const delBtns = document?.querySelectorAll('.component-keypad-popup button, .ui-webnumpad button');
                
        delBtns?.forEach((list)=>{
            const delIcons = list.querySelector('.ico-delete-keypad');

            if(delIcons){
                // list.setAttribute('title', '입력내용 삭제'); //A11YTASK-185 마크업에서 title="입력내용 삭제" 추가
            }
        });

        const newNumLiveText = document.createElement('div');
        newNumLiveText.setAttribute('aria-live','polite');
        newNumLiveText?.setAttribute('style', 'position:absolute;top:-99999px;left:-99999px;opacity:0;');
        newNumLiveText.classList.add('numpad-live');
        document.querySelector('body').append(newNumLiveText);

        const liveAreaEles = document.querySelectorAll('.numpad-live');

        liveAreaEles?.length && liveAreaEles?.forEach((item, idx) => {
            if(idx !== 0) item.remove();
        })

        const webNumPadEles = document.querySelectorAll('.keypad-group.ui-webnumpad');

        webNumPadEles?.length && webNumPadEles?.forEach((item, idx) => {
            const validationAreaEle = item?.querySelectorAll('.validation-area .validation-txt-set'); 
            const inputAreaEle = item?.querySelector('[data-role="numpad-amount-val"]');
            // console.log('inputAreaEle', inputAreaEle);

            inputAreaEle?.setAttribute('role','img'); //A11YTASK-633 :접근성 대응 (2025.06.19)

            inputAreaEle && checkValuLiveText(inputAreaEle,{
                subtree: true,
                attributes: true,
                attributeOldValue: true,
                attributeFilter: ['class'],
            }, 'default');

            validationAreaEle?.length && validationAreaEle?.forEach((list) => {
                checkValuLiveText(list,{
                    subtree: true,
                    attributes: true,
                    attributeOldValue: true,
                    attributeFilter: ['class'],
                }, 'validation');
            });
        });
    } catch (error) {
        throw new Error(`isA11yKeyPad ${error}`);
    }
}

/**
 * @summary 키패드 접근성, 벨리데이션 텍스트 및 현재 인풋입력 텍스트 읽어주는 함수
 * @description [관련지침]   적절한 대체텍스트의 제공
 * @param $target {Selector} 선택자 Node
 * @param $option 
 * @param $type {String} default, validation
 */
export function checkValuLiveText($target, $option, $type){
    const observer = new MutationObserver(a11yDebounce(async (mutations) => {
        const { target } = mutations[0];
        
        if(target.classList.contains('show')){
            let textValue = '';
            let delayTime = 2000;

            if($type === 'default'){
                const numPadValEles = $('[data-role="numpad-amount-val"]').parent().find('.show');
                const numPadVal = $('[data-role="numpad-amount-val"]'); //A11YTASK-156 :접근성 대응

                textValue = numPadValEles.text();

                const newVal = unitSet(Number(textValue));

                const numVal = setCommaWithDecimalPoint(textValue);//A11YTASK-156 :접근성 대응
                // console.log('numVal',numVal)
                numPadVal.removeAttr('title') //A11YTASK-156 :접근성 대응 (2025.03.28)
                // numPadVal.attr('aria-label', numVal + '원') //A11YTASK-156 :접근성 대응 (2025.03.28)
                console.log('aaaaaaaa2025.06.19')
                numPadVal.attr('aria-label', numVal) //A11YTASK-633 :접근성 대응 (2025.06.19)
                numPadVal.find('span').attr('aria-hidden', 'true') //A11YTASK-156 :접근성 대응 (2025.03.28)


                new Promise(async (resolve) => {
                    once(numpadSetLiveText(newVal));

                    //벨리데이션 체크 텍스트 다 읽히고 초기화시키기
                    const delay = new Promise((resolve) => setTimeout(resolve, 250 * newVal?.length));

                    await delay;

                    resolve('success');
                }).then(async () => {
                    //aria-live 영역 초기화
                    document.querySelector('.numpad-live').innerHTML = '';
                });
            }else if($type === 'validation'){
                const textValue = target.textContent.replace(/\s/g, "");

                const delay = new Promise((resolve) => setTimeout(resolve, 250 * textValue?.length));

                await delay;

                await new Promise(async (resolve) => {
                    once(numpadSetLiveText(textValue));

                    //벨리데이션 체크 텍스트 다 읽히고 초기화시키기
                    const delay = new Promise((resolve) => setTimeout(resolve, 250 * textValue?.length));

                    await delay;

                    resolve('success');
                }).then(() => {
                    //aria-live 영역 초기화
                    document.querySelector('.numpad-live').innerHTML = '';
                });
            }
        }
    },1000));

    observer.observe($target, $option);
}
    
/**
 * @summary 함수 한번만 실행시키는 로직(유틸함수)
 * @param $target {Selector} 선택자 Node
 *
 */
export function once(fn, context){
    let result;

    return function(){
        if(fn){
            result = fn.apply(context || this, arguments);

            fn = null;
        }

        return result;
    }
}

/**
 * @summary 키패드 aria-live에 현재 텍스트 넣는 함수(유틸함수)
 * @param text {String} 
 * @async 
 */
export async function numpadSetLiveText(text){    
    const liveArea = document.querySelector('.numpad-live');
    const createText = document.createElement('div');
    createText.innerText = `${text}`;

    liveArea.innerHTML = `<div>${text}</div>`;
}

/**
 * @summary 숫자 한글단위 추가를 위한 분리 함수(유틸함수)
 * @param num {Number} 
 * 
 */
export function unitSet(num) { 
    const _this = this;
    const tempVal = num.toString().replace(/\B(?=(\d{4})+(?!\d))/g, ",");
    const tempArr = tempVal.split(',').reverse();
    
    const unitArr = ["", "만", "억", "조", "경"];
    const maxUnitString = unitArr.length;
    let unitText = tempArr.map((v, i) => {
        if (i < maxUnitString && Number(v) > 0) return `${setCommaWithDecimalPoint(v)}${unitArr[i]}`;
    }).reverse().join(' ').trim();
    return (unitText ? unitText : "0") + "원";
}

/**
 * @summary 천단위 콤마 찍어주는 함수(유틸함수)
 * @param val {Number}  
 */
export function setCommaWithDecimalPoint(val){
    try {
        var parts = Number(val).toString().split(".");
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] || parts.length === 2 ? "." + parts[1] : "");
    } catch (error) {
        return val
    }
}

/**
 * @summary 내계좌(최근에 보낸 계좌) 삭제버튼 접근성 추가(유틸함수)
 */
export function isA11yRectList(){
    const rectItems = document.querySelectorAll('.rec-list-item .rec-list-del');

    if(rectItems){
        rectItems?.forEach((list) => {
            list.setAttribute('aria-hidden','true');
        });
    }
}

/**
 * @summary 스크립트 최초 실행 a11y 체크해서 body에 class넣기 (퍼블에서만 사용)
 */
export function isA11yAddClass(){
    const urlParams = window.location.href.split('?').pop();
    if (urlParams.indexOf('a11y') > -1) {
        let strKey, strValue;
        let index = urlParams.indexOf('a11y');
        let selectedParams = urlParams.slice(index);

        index = selectedParams.indexOf('&');

        if(index > -1){
            selectedParams = selectedParams.slice(0, index);
        }

        strKey = selectedParams.split('=')[0];
        strValue = selectedParams.split('=')[1];

        if (strKey == 'a11y') {
            if (!$('body').hasClass(strKey)) {
                $('body').addClass(strKey).addClass(strValue);
            }        
        }
    }
}

/**
 * @summary 모든 a태그 role=button없을때 button넣기 - 
 * @description [관련지침]   초점 이동
 * 모바일에서 올바른 outline 표시를 위해 추가
 * 텍스트 영역만 잡히거나 여러 요소를 포함한 경우 outline 이 각각 표시되는 것을 막기위해
 */
export function isA11yButtonRole(){

    $(document).ready(function(){
        const backBtnEles = $('a[href]').not('[role="tab"]');

        backBtnEles?.length && backBtnEles?.each((_, item) => {
            if(item.getAttribute('role') != null && item.getAttribute('role') != '') return;
            item.setAttribute('role','button');
        });
    });
}

/**
 * @summary a태그이지만 role="tab" 예외 케이스 적용
 * @description [관련지침]   대체텍스트 - 용도와 상테값을 정보를 정확히 제공 하기 위함
 */
export function isA11yTabButtonRole(){
    $('body').removeAttr('style');

    const roleTabEles = document?.querySelectorAll('.tab-item:not(.new) > a.tab-link');

    roleTabEles?.length && roleTabEles?.forEach((item) => {
        const spanEle = item?.querySelector('.hide-txt');

        item?.setAttribute('role', 'tab');
        spanEle && spanEle?.setAttribute('aria-hidden','true');
    });
}

/**
 * @summary 바텀팝업형태 dateSpinner 이전 다음버튼 위치 재설정 필요
 * @description [관련지침]   누르기 보장 
 * @param $el {Selector}   
 */
export function isA11ydateSpinnerPrevNextPos($el){    
    const elNum = $el?.length - 1 < 0 ? 0 : $el?.length - 1; //다중팝업 발생시 해당 팝업으로 포커스이동 적용 num
    
    const $target = $el;

    if($(document).find('.toast-wrap')?.length) {
        //toast팝업 있을시 실행 안되게
        setTimeout(() => {
            $(document).find('.toast-wrap .toast-txt').focus();
        },300);

        return;
    }

    if(!$target?.length && !$target[elNum]?.find('.control-btn')) return;

    !$target[elNum] && $target[elNum].classList.contains('activePopup') && $target[elNum].setAttribute('aria-hidden','false');

    $(document).ready(async () => {

        const delay = new Promise((resolve) => setTimeout(resolve, 500));

        await delay;

        const removeIdContent = document.querySelector('#content-mmk');
        removeIdContent.setAttribute('aria-hidden','false')
        removeIdContent.removeAttribute('aria-hidden');
        if(!$target?.length){
            let divTitle = $('.activeSlide')?.find('.component-text-icon .tit, .text-icon-group .tit').eq(0);
            let topHeaderTitle = $('.activeSlide')?.find('.tit-head > *:first-child:not(.hide-txt)') || $target[elNum]?.querySelector('.tit-header > *:first-child:not(.hide-txt)');
            const headerTitle = $('.activeSlide')?.find('.title-field-popup:not(strong)');
            const leftTitle = $('.activeSlide')[0]?.querySelector('.header-content .home-tit') || $('.activeSlide')[0]?.querySelector('.header-content .tit-head') || $('.activeSlide')[0]?.querySelector('.home-header-tit .home-tit');
            const prodnameTitle = $('.activeSlide')?.find('.prodname-tit-field');
            const gouidTxt = $('.activeSlide')?.find('.guide-state');
            const isFocusEles =$('.activeSlide')?.find('a, button:not(.close-btn), input, textarea, select');

            if($('.activeSlide')?.find('.tit-head > *:first-child:not(.hide-txt)')[0] && !$('.activeSlide')?.find('.tit-head > *:first-child:not(.hide-txt)')[0].textContent?.length){
                //span내부 빈텍스트 존재 대응
                topHeaderTitle = undefined;
            }

            if($('.activeSlide')?.find('.tit-header > *:first-child:not(.hide-txt)')[0] && !$('.activeSlide')?.find('.tit-header > *:first-child:not(.hide-txt)')[0].textContent?.length){
                //span내부 빈텍스트 존재 대응
                topHeaderTitle = undefined;
            }

            if($('.activeSlide')?.find('.tit-header > *:first-child:not(.hide-txt)')[0] && !$('.activeSlide')?.find('.tit-header').parent().hasClass('ui-animate') && $('.activeSlide')?.find('.tit-header').css('opacity') === '0' || $('.activeSlide')?.find('.tit-header > *:first-child:not(.hide-txt)').css('opacity') === '0'){
                $('.activeSlide')?.find('.tit-header').attr({'aria-hidden':'true'});
                $('.activeSlide')?.find('.tit-header > *:first-child:not(.hide-txt)').removeAttr('aria-hidden');
                $('.activeSlide')?.find('.tit-header > *:first-child:not(.hide-txt)').removeAttr('tabindex');
                topHeaderTitle = undefined;
            }
            
            if(!$('.activeSlide')?.find('.tit-header')[0]?.innerText?.replace(/\n|\r|\s*/g, '')?.length && !$('.activeSlide')?.find('.tit-header .logo-kbankpay')[0]){
                $('.activeSlide')?.find('.tit-header').attr({'aria-hidden':'true'});
                topHeaderTitle = undefined;
            }

            if(!!topHeaderTitle?.length && topHeaderTitle?.focus()){
                topHeaderTitle.attr('tabindex','0');
                topHeaderTitle.attr('aria-hidden','false');
                setTimeout(() => {
                    topHeaderTitle?.focus();
                },200);
    
                return;
            }
    
            if(!!headerTitle?.length && headerTitle?.focus()){
                headerTitle.attr('tabindex','0');
                headerTitle.attr('aria-hidden','false');
                setTimeout(() => {
                    headerTitle?.focus();
                },200);
    
                return;
            }

            if(leftTitle){
                $(leftTitle).attr('aria-hidden','false');
                $(leftTitle).attr('tabindex','0');
                setTimeout(() => {
                    $(leftTitle)?.focus();
                },200);

                return;
            }

            if(divTitle?.length && divTitle?.focus()){
                divTitle.attr('tabindex','0');
                divTitle.attr('aria-hidden','false');
                setTimeout(() => {
                    divTitle?.focus();
                },200);

                return;
            }

            if(gouidTxt?.length && gouidTxt?.focus()){
                gouidTxt.attr('tabindex','0');
                gouidTxt.attr('aria-hidden','false');
                setTimeout(() => {
                    gouidTxt?.focus();
                },200);

                return;
            }
    
            if(isFocusEles){
                setTimeout(() => {
                    isFocusEles[0]?.focus();
                },200);
    
                return;
            }
    
            if(!!prodnameTitle?.length && prodnameTitle?.focus()){
                prodnameTitle.attr('tabindex','0');
                prodnameTitle.attr('aria-hidden','false');
                setTimeout(() => {
                    prodnameTitle?.focus();
                },200);
    
                return;
            }

            return;
        }

        console.log($target[elNum])

        if(!target && !$target[elNum] && !$target[elNum]?.find('.swiper-wrapper')) return;
        
        await $target[elNum].find('.swiper-wrapper').find("*").attr({'aria-hidden':'true','tabindex':'-1'});

        await isA11ySwiperSelect($target[elNum]);

        await $target[elNum].find('.control-btn').each((idx, item) => {
            const swipeDivBox = item.parentElement;
            const ulGetBoundRect = swipeDivBox.getBoundingClientRect();
            const { top, width, bottom } = ulGetBoundRect;
            const buttonHeight = 40;

            const topOffset = top - buttonHeight + 20
            const bottomOffset = bottom - 20;

            if(idx % 2){
                //이전 버튼
                item.setAttribute('style', `${!width && 'visibility:hidden'};position:fixed;top:${bottomOffset}px;width:${width ? width : 1}px;height:${buttonHeight}px;z-index:5;`);                   
            }else{
                //다음 버튼
                item.setAttribute('style', `${!width && 'visibility:hidden'};position:fixed;top:${topOffset}px;width:${width ? width : 1}px;height:${buttonHeight}px;z-index:5;`);
            }
        });

        const closeBtns = $el[elNum]?.find('.close-btn');
        closeBtns && closeBtns.each((idx,list) => {
            if(idx > 0){
                list.remove();
            }
        });

        //ios swiper page 적용안되는 현상 대응
        const pageNationEle = $target[elNum].find('.swiper-pagination > span');
        pageNationEle?.length && pageNationEle.each((index, item) => {
            const isActive= $(item).hasClass('swiper-pagination-bullet-active');

            if(isActive){
                $(item).attr({'aria-label':`총 ${pageNationEle?.length}개 슬라이드 중 ${index+1} 선택됨`, 'role':'button'});
            }else{
                $(item).attr({'aria-label':`총 ${pageNationEle?.length}개 슬라이드 중 ${index+1} 번째`, 'role':'button'});
            }
        })

        const delay2 = new Promise((resolve) => setTimeout(resolve, 500));

        await delay2;

        if($target[elNum]?.find('.ui-input textarea.ui-text-del')?.length){//textarea자동으로 focus가는 로직 놔두기
            return;
        }
        
        if([...new Set($target)]?.length > 1){
            //데이트 스피너 형태 팝업 여러개 떴을때 버그 대응
            $('.activePopup').attr('aria-hidden','false');
        }
        
        if(!!$target[elNum]?.find('.control-btn').length){
            $target[elNum]?.find('.control-btn')[0]?.focus();
        }else{
            $target[elNum]?.find('.close-btn').focus();
        }

        let topHeaderTitle = $target[elNum]?.find('.tit-head > *:first-child:not(.hide-txt)') || $target[elNum]?.find('.tit-header > *:first-child:not(.hide-txt)') || $target[elNum]?.find('.tit-head');
        const headerTitle = $target[elNum]?.find('.title-field-popup:not(strong)').eq(0);
        const headerDivTit = $target[elNum]?.find('.popup-header .title-group > *:first-child:not(.hide-txt):not(.ico-figure)') || $target[elNum]?.find('.popup-header .title-group > *:first-child:not(.hide-txt):not(.ico-figure)');
        const leftTitle = $target[elNum] && $target[elNum][0] && ($target[elNum][0]?.querySelector('.header-content .home-tit') || $target[elNum][0]?.querySelector('.header-content .tit-head') || $target[elNum][0]?.querySelector('.home-header-tit .home-tit'));
        const isFocusEles = $target[elNum]?.find('a, button:not(.close-btn), input, textarea, select');
        const prodnameTitle = $target[elNum]?.find('.prodname-tit-field');
        const contentTxt = ($target[elNum]?.find('.popup-header .title-group > .title-field-01')[0] && $target[elNum]?.find('.popup-header .title-group > .title-field-01')) || ($target[elNum]?.find('.popup-header .title-group > .title-field-21')[0] && $target[elNum]?.find('.popup-header .title-group > .title-field-21'));
        const gouidTxt = $target[elNum]?.find('.guide-state');
        const countTxt = $target[elNum]?.find('.card-group .txt-count').eq(0);
        const focusTextWrap = $target[elNum]?.find('.interest-text-wrap .interest-text.step1');
        const cardTit = $target[elNum]?.find('.text-icon-group .tit').eq(0);
        const bottomTit = $target[elNum]?.find('.text-list-group2 .tit-01').eq(0);
        const textField = $target[elNum]?.find('.title-group .title-field-21').eq(0);
        const textAlert = $target[elNum]?.find('.popup-inner .txt-alert').eq(0);
        const keypadPlaceHolder = $target[elNum]?.find('.keypad-value .placeholder').eq(0);
        const eventImg = $target[elNum]?.find('.popup-inner .evt-img2').eq(0);


        const FOCUS_DELAY = 500;
        
        if($target[elNum]?.find('.tit-head')[0] && $target[elNum]?.find('.tit-head > *').hasClass('hide-txt')){
            //span내부 빈텍스트 존재 대응
            topHeaderTitle = undefined;
        }

        if($target[elNum]?.find('.tit-head')[0] && !$target[elNum]?.find('.tit-head')[0]?.textContent?.length){
            $target[elNum]?.find('.tit-head')[0]?.setAttribute('aria-hidden','true');
            topHeaderTitle = undefined;
        }

        if($target[elNum]?.find('.tit-head > *:first-child:not(.hide-txt)')[0] && !$target[elNum]?.find('.tit-head > *:first-child:not(.hide-txt)')[0]?.textContent?.length){
            //span내부 빈텍스트 존재 대응
            topHeaderTitle = undefined;
        }

        if($target[elNum]?.find('.tit-header > *:first-child:not(.hide-txt)')[0] && !$target[elNum]?.find('.tit-header > *:first-child:not(.hide-txt)')[0]?.textContent?.length){
            //span내부 빈텍스트 존재 대응
            topHeaderTitle = undefined;
        }

        if($target[elNum]?.find('.tit-header > *:first-child:not(.hide-txt)')[0] && !$target[elNum]?.find('.tit-header').parent().hasClass('ui-animate') && $target[elNum]?.find('.tit-header').css('opacity') === '0' || $target[elNum]?.find('.tit-header > *:first-child:not(.hide-txt)').css('opacity') === '0'){
            $target[elNum]?.find('.tit-header').attr({'aria-hidden':'true'});
            $target[elNum]?.find('.tit-header > *:first-child:not(.hide-txt)').removeAttr('aria-hidden');
            $target[elNum]?.find('.tit-header > *:first-child:not(.hide-txt)').removeAttr('tabindex');
            topHeaderTitle = undefined;
        }
        

        if(!!topHeaderTitle && !!topHeaderTitle?.length && topHeaderTitle?.focus()){
            topHeaderTitle.attr('tabindex','0');
            topHeaderTitle.attr('aria-hidden','false');
            setTimeout(() => {
                topHeaderTitle?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(!!headerTitle?.length && headerTitle?.focus()){
            headerTitle.attr('tabindex','0');
            headerTitle.attr('aria-hidden','false');
            setTimeout(() => {
                headerTitle?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(leftTitle){
            $(leftTitle).attr('aria-hidden','false');
            $(leftTitle).attr('tabindex','0');
            setTimeout(() => {
                $(leftTitle)?.focus();
            },FOCUS_DELAY);

            return;
        }
        
        if(!!headerDivTit?.length && headerDivTit?.focus()){
            headerDivTit.attr('tabindex','0');
            headerDivTit.attr('aria-hidden','false');
            setTimeout(() => {
                headerDivTit?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(!!contentTxt?.length && contentTxt?.focus()){
            contentTxt.attr('tabindex','0');
            contentTxt.attr('aria-hidden','false');
            setTimeout(() => {
                contentTxt?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(!!gouidTxt?.length && gouidTxt?.focus()){
            gouidTxt.attr('tabindex','0');
            gouidTxt.attr('aria-hidden','false');
            setTimeout(() => {
                gouidTxt?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(!!focusTextWrap?.length && focusTextWrap?.focus()){
            focusTextWrap.attr('tabindex','0');
            focusTextWrap.attr('aria-hidden','false');
            setTimeout(() => {
                focusTextWrap?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(!!bottomTit?.length && bottomTit?.focus()){
            bottomTit.attr('tabindex','0');
            bottomTit.attr('aria-hidden','false');
            setTimeout(() => {
                bottomTit?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(!!textField?.length && textField?.focus()){
            textField.attr('tabindex','0');
            textField.attr('aria-hidden','false');
            setTimeout(() => {
                textField?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(!!textAlert?.length && textAlert?.focus()){
            textAlert.attr('tabindex','0');
            textAlert.attr('aria-hidden','false');
            setTimeout(() => {
                textAlert?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(!!keypadPlaceHolder?.length && keypadPlaceHolder?.focus()){
            keypadPlaceHolder.attr('tabindex','0');
            keypadPlaceHolder.attr('aria-hidden','false');
            setTimeout(() => {
                keypadPlaceHolder?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(!!eventImg?.length && eventImg?.focus()){
            eventImg.attr('tabindex','0');
            eventImg.attr('aria-hidden','false');
            setTimeout(() => {
                eventImg?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(!!cardTit?.length && cardTit?.focus()){
            cardTit.attr('tabindex','0');
            cardTit.attr('aria-hidden','false');
            setTimeout(() => {
                cardTit?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(!!countTxt?.length && countTxt?.focus()){
            countTxt.attr('tabindex','0');
            countTxt.attr('aria-hidden','false');
            setTimeout(() => {
                countTxt?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(isFocusEles){
            setTimeout(() => {
                isFocusEles[0]?.focus();
            },FOCUS_DELAY);

            return;
        }

        if(!!prodnameTitle?.length && prodnameTitle?.focus()){
            prodnameTitle.attr('tabindex','0');
            prodnameTitle.attr('aria-hidden','false');
            setTimeout(() => {
                prodnameTitle?.focus();
            },FOCUS_DELAY);

            return;
        }
    });
}

/**
 * @summary 팝업에서 데이터 스피너 뜰때 데이터스피너 접근성 대응 로직(PopupExternal.js)
 * @description [관련지침]   누르기 보장
 * @param $target {HTMLElement}   html element
 */
export function isA11ySwiperSpinnerUpdate($target){
    const uiSwiperEles = $target.find('.group-spinner-swiper, .ui-swiper');

    uiSwiperEles?.length && uiSwiperEles?.each((idx, item) => {
        if($(item).hasClass('carousel-select-group')){
            return;
        }
        setTimeout(() => {
            const sw = $(item).data('ui').swiper;

            const isActive = $(item).find('.swiper-slide.swiper-slide-active').index();
            const slidesEle = $(item).find('.swiper-slide');
            const ulWrap = $(item).find('.swiper-container')[0];
                
            //버튼 절대 좌표값 계산
            //const getPageOffset = window.pageYOffset;
            const swipeDivBox = ulWrap.parentElement;
            const ulGetBoundRect = swipeDivBox.getBoundingClientRect();
            const { top, width, bottom } = ulGetBoundRect;
            const buttonHeight = 40;

            const topOffset = top - buttonHeight
            const bottomOffset = bottom;

            const selectText = slidesEle.eq(sw.activeIndex).text();

            const prevBtn = document.createElement('button');
            prevBtn.classList.add('control-btn');
            prevBtn.classList.add('prev__btn');

            const nextBtn = document.createElement('button');
            nextBtn.classList.add('control-btn');
            nextBtn.classList.add('next__btn');

            prevBtn.setAttribute('role','button');
            prevBtn.setAttribute('style', `${!width && 'visibility:visible'};position:fixed;top:${topOffset}px;width:${width ? width : 1}px;height:${buttonHeight}px;z-index:5;`);                                    
            
            $(swipeDivBox).find('.prev__btn').attr('aria-label', `${selectText}, 이전 (감소 버튼)`);

            const $SwiperTarget = $(sw.$el).find('.swiper-wrapper');

            // TODO - aria-disabled
            if(isActive === 0){
                $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'true');
            }else{
                $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'false');
            }

            $(swipeDivBox).find('.prev__btn')?.off('click.spinnerSwiper')?.on('click.spinnerSwiper', (e) => {

                const activeIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();

                
                const slidesEles = $(e.currentTarget).parent().find('.swiper-slide').eq(activeIndex - 1);

                setTimeout(() => {
                    const currentIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index()

                    // TODO - aria-disabled
                    if(currentIndex - 1 === 0){
                        $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'true');
                    }else{
                        $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'false');
                    }
                    $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'false');

                    if(activeIndex - 1 === 0) return;
                });

                if(activeIndex -1 >= 0){

                    sw.slideTo(activeIndex - 1);
                }

                //spinner변경 텍스트
                setTimeout(() => {
                    let currentText = '';

                    const activeItems = $(e.currentTarget).parent().parent().find('.swiper-slide-active');
    
                    activeItems?.each((idx,list) => {
                        currentText += list.innerText;
                        currentText += ' ';
                    });
    
    
                    setTimeout(() => {
                        const selectDiv = document.querySelector('.spinner-live');
    
                        const createText = document.createElement('div');
                        createText.innerText = `${currentText} 선택`;
                        
                        $(selectDiv)?.children().remove();
    
                        ($(selectDiv)?.children()?.length === 0 && selectDiv) && selectDiv.append(createText);
    
                        setTimeout(() => {
                            createText.remove();
                        },2000);
                    },1000);
                },500);
            });


            nextBtn.setAttribute('role','button');
            nextBtn.setAttribute('style', `${!width && 'visibility:visible'};position:fixed;top:${bottomOffset}px;width:${width ? width : 1}px;height:${buttonHeight}px;z-index:5;`); 

            $(swipeDivBox).find('.next__btn').attr('aria-label', `${selectText}, 다음 (증가 버튼)`);

            // TODO - aria-disabled
            if(isActive === maxLength -1){
                $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'true');
            }else{
                $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'false');
            }

            $(swipeDivBox).find('.next__btn')?.off('click.spinnerSwiper')?.on('click.spinnerSwiper', (e) => {
                
                const activeIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();

                const slidesEles = $(e.currentTarget).parent().find('.swiper-slide').eq(activeIndex + 1);

                isDateSpinnerNextTextForceReading(e.currentTarget, slidesEles?.text());

                const maxLength = $(e.currentTarget).parent().find('.swiper-slide')?.length;

                setTimeout(() => {
                    const currentIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();

                    // TODO - aria-disabled
                    if(currentIndex === maxLength -1){
                        $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'true');
                    }else{
                        $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'false');
                    }
                    $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'false');

                    if(currentIndex === maxLength -1) return;
                });

                if(activeIndex + 1 < maxLength){

                    sw.slideTo(activeIndex + 1);
                }

                //spinner변경 텍스트
                setTimeout(() => {
                    let currentText = '';

                    const activeItems = $(e.currentTarget).parent().parent().find('.swiper-slide-active');
    
                    activeItems?.each((idx,list) => {
                        currentText += list.innerText;
                        currentText += ' ';
                    });
    
    
                    setTimeout(() => {
                        const selectDiv = document.querySelector('.spinner-live');
    
                        const createText = document.createElement('div');
                        createText.innerText = `${currentText} 선택`;
                        
                        $(selectDiv)?.children().remove();
    
                        ($(selectDiv)?.children()?.length === 0 && selectDiv) && selectDiv.append(createText);
    
                        setTimeout(() => {
                            createText.remove();
                        },2000);
                    },1000);
                },500);
            });

            if($('#FPMDPT21000A300W')?.length){
                slidesEle.each((item, idx) => {
                    if($(item).text() === '직접입력'){
                        $(item).remove();
                    }
                });
            }

            isA11ySwiperBtnChangeAria(); //스와이프 버튼 aria-hidden

            $(ulWrap).attr('role','presentation');
            $(ulWrap).attr('aria-hidden','true');


            sw.on('slideChangeTransitionEnd', (sw) => {
                const { activeIndex, slides, $wrapperEl } = sw;


                if($(slides[activeIndex]).text() === '매월'){
                    $('#monthlyCyclSwiper').show();
                    $('#weeklyCyclSwiper').hide();
                }

                if($(slides[activeIndex]).text() === '매주'){
                    $('#monthlyCyclSwiper').hide();
                    $('#weeklyCyclSwiper').show();
                }

                const curText = slides[activeIndex].innerText;


                $(swipeDivBox).find('.prev__btn').attr('aria-label', `${curText}, 이전 (감소 버튼)`);
                $(swipeDivBox).find('.next__btn').attr('aria-label', `${curText}, 다음 (증가 버튼)`);

                
                let currentText = '';

                isA11ySwiperBtnChangeAria(); //스와이프 버튼 aria-hidden
            });

            setTimeout(() => {
                $(swipeDivBox).find('.prev__btn').each((idx, item) => {
                    if(idx > 0){
                        $(item).remove();
                    }
                });

                $(swipeDivBox).find('.next__btn').each((idx, item) => {
                    if(idx > 0){
                        $(item).remove();
                    }
                });
            },500);
        },500);
    });
}

/**
 * @summary DateSpinner.js에서 스피너 접근성 대응
 * @description [관련지침]   누르기 보장
 * @param $swiper {Array}
 * @param $popup {HTMLElement}   html element
 * 
 */    
export function isA11yGroupSpinnerUpdate($swiper=[], $popup){

    $swiper?.length && $swiper.forEach((swipe) => {

        swipe.init();
        const item = $(swipe?.$wrapperEl);

        const isActive = $(item).find('.swiper-slide.swiper-slide-active').index();
        const slidesEle = $(item).find('.swiper-slide');
        const ulWrap = $(item)[0];
        const maxLength = $(item).find('.swiper-slide')?.length;

        //버튼 절대 좌표값 계산
        //const getPageOffset = window.pageYOffset;
        const swipeDivBox = ulWrap?.parentElement;
        const ulGetBoundRect = swipeDivBox?.getBoundingClientRect();
        const { top, width, bottom } = ulGetBoundRect;
        const buttonHeight = 40;

        const topOffset = top - buttonHeight;
        const bottomOffset = bottom;

        const selectText = slidesEle.eq(isActive).text();

        const prevBtn = document.createElement('button');
        prevBtn.classList.add('control-btn');
        prevBtn.classList.add('prev__btn');

        const nextBtn = document.createElement('button');
        nextBtn.classList.add('control-btn');
        nextBtn.classList.add('next__btn');

        prevBtn.setAttribute('role','button');
        prevBtn.setAttribute('style', `${!width && 'visibility:visible'};position:fixed;top:${topOffset}px;width:${width ? width : 1}px;height:${buttonHeight}px;z-index:-5;`);                                    
        
        prevBtn.setAttribute('aria-label', `${selectText}, 이전 (감소 버튼)`);
        
        nextBtn.setAttribute('role','button');
        nextBtn.setAttribute('style', `${!width && 'visibility:visible'};position:fixed;top:${bottomOffset}px;width:${width ? width : 1}px;height:${buttonHeight}px;z-index:-5;`); 

        nextBtn.setAttribute('aria-label', `${selectText}, 다음 (증가 버튼)`);

        $(ulWrap).attr('role','presentation');
        $(ulWrap).attr('aria-hidden','true');

        const $SwiperTarget = $(swipe.$el).find('.swiper-wrapper');

        // TODO - aria-disabled
        if(isActive === 0){
            $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'true');
        }else{
            $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'false');
        }

        $(swipeDivBox).find('.prev__btn')?.off('click.spinnerSwiper')?.on('click.spinnerSwiper', (e) => {

            const activeIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();

            const slidesEles = $(e.currentTarget).parent().find('.swiper-slide').eq(activeIndex - 1);

            isDateSpinnerNextTextForceReading(e.currentTarget, slidesEles?.text());

            setTimeout(() => {
                const currentIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index()

                // TODO - aria-disabled
                if(currentIndex - 1 === 0){
                    $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'true');
                }else{
                    $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'false');
                }
                $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'false');

                if(activeIndex - 1 === 0) return;
            });

            if(activeIndex -1 >= 0){
                swipe.slideTo(activeIndex - 1);
            }

            //spinner변경 텍스트
            setTimeout(() => {
                let currentText = '';

                const activeItems = $(e.currentTarget).parent().parent().find('.swiper-slide-active');

                activeItems?.each((idx,list) => {
                    currentText += list.innerText;
                    currentText += ' ';
                });


                setTimeout(() => {
                    const selectDiv = document.querySelector('.spinner-live');

                    const createText = document.createElement('div');
                    createText.innerText = `${currentText} 선택`;
                    
                    $(selectDiv)?.children().remove();

                    ($(selectDiv)?.children()?.length === 0 && selectDiv) && selectDiv.append(createText);

                    setTimeout(() => {
                        createText.remove();
                    },2000);
                },1000);
            },500);
        });

        // TODO - aria-disabled
        if(isActive === maxLength -1){
            $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'true');
        }else{
            $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'false');
        }

        $(swipeDivBox).find('.next__btn')?.off('click.spinnerSwiper')?.on('click.spinnerSwiper', (e) => {
            const maxLength = $(e.currentTarget).parent().find('.swiper-slide')?.length;
            
            const activeIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();

            const slidesEles = $(e.currentTarget).parent().find('.swiper-slide').eq(activeIndex + 1);

            setTimeout(() => {
                const currentIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();

                // TODO - aria-disabled
                if(currentIndex === maxLength -1){
                    $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'true');
                }else{
                    $(swipeDivBox).find('.next__btn').attr('aria-disabled', 'false');
                }
                $(swipeDivBox).find('.prev__btn').attr('aria-disabled', 'false');

                if(currentIndex === maxLength -1) return;
            });

            isDateSpinnerNextTextForceReading(e.currentTarget, slidesEles?.text());

            if(activeIndex + 1 < maxLength){
                swipe.slideTo(activeIndex + 1);
            }

            //spinner변경 텍스트
            setTimeout(() => {
                let currentText = '';

                const activeItems = $(e.currentTarget).parent().parent().find('.swiper-slide-active');

                activeItems?.each((idx,list) => {
                    currentText += list.innerText;
                    currentText += ' ';
                });


                setTimeout(() => {
                    const selectDiv = document.querySelector('.spinner-live');

                    const createText = document.createElement('div');
                    createText.innerText = `${currentText} 선택`;
                    
                    $(selectDiv)?.children().remove();

                    ($(selectDiv)?.children()?.length === 0 && selectDiv) && selectDiv.append(createText);

                    setTimeout(() => {
                        createText.remove();
                    },2000);
                },1000);
            },500);
        });

        if($('#FPMDPT21000A300W')?.length){
            slidesEle.each((item, idx) => {
                if($(item).text() === '직접입력'){
                    $(item).remove();
                }
            });
        }
    
        swipe.on('slideChangeTransitionEnd', (sw) => {
            const { activeIndex, slides, $wrapperEl } = sw;


            if($(slides[activeIndex]).text() === '매월'){
                $('#monthlyCyclSwiper').show();
                $('#weeklyCyclSwiper').hide();
            }

            if($(slides[activeIndex]).text() === '매주'){
                $('#monthlyCyclSwiper').hide();
                $('#weeklyCyclSwiper').show();
                
            }

            const curText = slides[activeIndex]?.innerText;

            $(swipeDivBox).find('.prev__btn').attr('aria-label', `${curText}, 이전 (감소 버튼)`);
            $(swipeDivBox).find('.next__btn').attr('aria-label', `${curText}, 다음 (증가 버튼)`);

            
            let currentText = '';
            const activeItems = $($wrapperEl).parent().parent().find('.swiper-slide-active');

            isA11ySwiperBtnChangeAria(); //스와이프 버튼 aria-hidden

            setTimeout(() => {
                activeItems?.each((idx, list) => {
                    $(list).parent().parent().find('.prev__btn').attr('aria-label', `${list?.innerText}, 이전 (감소 버튼)`);
                    $(list).parent().parent().find('.next__btn').attr('aria-label', `${list?.innerText}, 다음 (증가 버튼)`);
                });
            });

            activeItems?.each((idx,list) => {
                currentText += list.innerText;
            });
        });

        setTimeout(() => {
            $(swipeDivBox).find('.prev__btn').each((idx, item) => {
                if(idx > 0){
                    $(item).remove();
                }
            });

            $(swipeDivBox).find('.next__btn').each((idx, item) => {
                if(idx > 0){
                    $(item).remove();
                }
            });

        },500);
    });
}

/**
 * @summary 바텀팝업형태 dateSpinner 이전 다음버튼 위치 재설정 필요
 * @description [관련지침]   누르기 보장
 * @param $el {HTMLElement}   html element
 * @async
 */ 
export async function isA11ySwiperPopupUpdate($el){
    const elNum = $el?.length - 1 < 0 ? 0 : $el?.length - 1; //다중팝업 발생시 해당 팝업으로 포커스이동 적용 num
    
    const $target = $el;

    if($(document).find('.toast-wrap')?.length) {
        //toast팝업 있을시 실행 안되게
        setTimeout(() => {
            $(document).find('.toast-wrap .toast-txt').focus();
        },300);

        return;
    }

    if(!$target?.length && !$target[elNum]?.find('.control-btn')) return;

    !$target[elNum] && $target[elNum].classList.contains('activePopup') && $target[elNum].setAttribute('aria-hidden','false');

    $(document).ready(async () => {
        const delay = new Promise((resolve) => setTimeout(resolve, 500));

        await delay;

        if(!$target[elNum] && !$target[elNum]?.find('.swiper-wrapper')) return;
        
        await $target[elNum].find('.swiper-wrapper').find("*").attr({'aria-hidden':'true','tabindex':'-1'});

        await isA11ySwiperSelect($target[elNum]);

        await $target[elNum].find('.control-btn').each((idx, item) => {
            const swipeDivBox = item?.parentElement;
            const ulGetBoundRect = swipeDivBox?.getBoundingClientRect();
            
            const buttonHeight = 40;

            if(ulGetBoundRect?.top && ulGetBoundRect?.bottom){
                const topOffset = ulGetBoundRect?.top - buttonHeight + 20
                const bottomOffset = ulGetBoundRect.bottom - 20;
                
                if(idx % 2){
                    //다음 버튼
                    item.setAttribute('style', `${!ulGetBoundRect?.width && 'visibility:hidden'};position:fixed;top:${bottomOffset}px;width:${ulGetBoundRect?.width ? ulGetBoundRect?.width : 1}px;height:${buttonHeight}px;z-index:5;`);                   
                    item.classList.add('next__btn');

                    //자동이체 스피너 텍스트 버그 대응
                    setTimeout(() => {
                        const buttonText = $(item).parent().find('.swiper-slide-active').text();
                        $(item)?.attr('aria-label', `${buttonText}, 다음 (증가 버튼)`);
                    },500);
                }else{
                    //이전 버튼
                    item.setAttribute('style', `${!ulGetBoundRect?.width && 'visibility:hidden'};position:fixed;top:${topOffset}px;width:${ulGetBoundRect?.width ? ulGetBoundRect?.width : 1}px;height:${buttonHeight}px;z-index:5;`);
                    item.classList.add('prev__btn');

                    //자동이체 스피너 텍스트 버그 대응
                    setTimeout(() => {
                        const buttonText = $(item).parent().find('.swiper-slide-active').text();
                        $(item)?.attr('aria-label', `${buttonText}, 이전 (감소 버튼)`);
                    },500);
                }
            }
        });

        const closeBtns = $el[elNum]?.find('.close-btn');
        closeBtns && closeBtns.each((idx,list) => {
            if(idx > 0){
                list.remove();
            }
        });

        //ios swiper page 적용안되는 현상 대응
        const pageNationEle = $target[elNum].find('.swiper-pagination > span');
        pageNationEle?.length && pageNationEle.each((index, item) => {
            const isActive= $(item).hasClass('swiper-pagination-bullet-active');

            if(isActive){
                $(item).attr({'aria-label':`총 ${pageNationEle?.length}개 슬라이드 중 ${index+1} 선택됨`, 'role':'button'});
            }else{
                $(item).attr({'aria-label':`총 ${pageNationEle?.length}개 슬라이드 중 ${index+1} 번째`, 'role':'button'});
            }
        })

        const delay2 = new Promise((resolve) => setTimeout(resolve, 500));

        await delay2;

        if($target[elNum]?.find('.ui-input textarea.ui-text-del')?.length){//textarea자동으로 focus가는 로직 놔두기
            return;
        }
        
        if([...new Set($target)]?.length > 1){
            //데이트 스피너 형태 팝업 여러개 떴을때 버그 대응
            $('.activePopup').attr('aria-hidden','false');
        }
        
        if(!!$target[elNum]?.find('.control-btn').length){
            $target[elNum]?.find('.control-btn')[0]?.focus();
        }else{
            $target[elNum]?.find('.close-btn').focus();
        }
    });
}

/**
 * @summary 같은 문자 중복일때 1번만 나오게 자르는 함수(유틸함수)
 * @param txt {String}
 */
export function isA11ySameTextFilter(txt){    
    const newText = [...new Set(txt)].join('').trim();

    return newText;
}

/**
 * @summary 접근성 관련 tag변경 유틸함수
 * @param tagOld HTMLElement || target
 * @param tagType 변경할 태그 타입
 */
export function isA11yChangeTag(tagOld, tagType="div"){
    

    const elem = (tagOld instanceof HTMLElement) ? tagOld : document.querySelector(tagOld);
    
    if(!elem || !(elem instanceof HTMLElement)) return;

    const children = elem.childNodes;
    const parent = elem.parentNode;
    const newNode = document.createElement(tagType);

    for(let a=0;a<elem.attributes.length;a++){
        newNode.setAttribute(elem.attributes[a].nodeName, elem.attributes[a].value);
    }
    
    for(let i=0,clen=children.length;i<clen;i++){
        newNode.appendChild(children[0]);
    }

    newNode.style.cssText = elem.style.cssText;
    parent.replaceChild(newNode, elem);

    return elem;
}

/**
 * @summary 비교할대상 찾기 유틸함수
 * @param $el 비교할 대상
 * @param range 찾을 요소
 */
export function getElementIdx($el, range){
    //.index() 동일
    
    if(!!range) return [].indexOf.call($el, range);

    return [].indexOf.call($el.parentNode.children, $el);
}

/**
 * @summary 예약이체 반팝업 설정 
 * @description [관련지침]   적절한 대체텍스트의 제공 
 * @param $el HTMLElement || target
 * @param isCheck {Boolean}
 */
export function isA11yReservationBtn($el, isCheck=true){    
    const preventBtnEles = $el.querySelectorAll('[data-role="valReset"]');

    if(preventBtnEles){
        preventBtnEles?.length && preventBtnEles?.forEach((item) => {
            item.setAttribute('aria-hidden', isCheck);
            item.setAttribute('title', '입력내용삭제');
            item.style.display = 'none';
        });
    }
}

/** 
 * @summary 위젯, 팝업 셀렉트 focus이동 및 hidetext 접근성 수정
 * @description [관련지침]   초점의 논리적 이동
 * @param $content HTMLElement || target
 * @async
 */
export async function isA11ySelectPopupOpenFocus($content){
    try {
        let focusEles = $content?.querySelectorAll('a, button, input, textarea, select');
        let headerTitle = $content?.querySelector('.title-field-popup:not(strong)');

        if(headerTitle){
            headerTitle.setAttribute('aria-hidden','false');
            headerTitle.setAttribute('tabindex','0');
        }

        focusEles = [headerTitle, ...focusEles].filter((item) => !!item && item);

        const delay = new Promise((resolve) => setTimeout(resolve, 1200));

        await delay;
        focusEles[0].focus();

    } catch (error) {
        throw new Error(`isA11ySelectPopupOpenFocus ${error}`);
    }
}

/** 
 * @summary 여러 focus로직 겹칠시 강제로 해당 target으로 focus줄때 사용정
 * 초점 제어 관련 유틸함수
 * @param $target HTMLElement
 * @param $maxCount Number
 * @async
 */
export async function isA11yForceTargetFocus($target, $maxCount=5){
    const targetEles = $($target).parent();
    // A11YTASK-190 : 접근성대응(2025-03-04)
    // const btnTitle1 = $(targetEles).find('.select-txt-wrap .txt-name').text();
    // const btnTitle2 = $(targetEles).find('.select-txt-wrap .txt-value01').text();
    // const btnTitleVal = btnTitle1 + btnTitle2;

    // console.log('btnTitle1',btnTitle1)
    //셀렉트 버튼 접근성 추가 대응(PopupSelect.js - a11yPopupInit)
    if($(targetEles).closest('.ui-input').hasClass('done')){
        $(targetEles).closest('.ui-input').find('.ui-select-btn').children().not('.bl-selectbox').removeAttr('aria-hidden');
        
        console.log('isA11yForceTargetFocus')
        if($(targetEles).closest('.ui-input').find('.ui-select-btn').text()?.length){
            $(targetEles).find('.ui-select-btn').attr('aria-selected','true');
            $(targetEles).find('.select-txt-wrap').removeAttr('aria-hidden');
            // $(targetEles).find('.ui-select-btn').attr('title', btnTitleVal + ' 선택됨'); // A11YTASK-190 : 접근성대응(2025-03-04)
            // $(targetEles).find('.ui-select-btn').attr('title', '선택됨'); // A11YTASK-190 : 접근성대응(2025-03-04)
        }
    }else{
        $(targetEles).closest('.ui-input').find('.ui-select-btn').children().attr('aria-hidden', 'true');
        $(targetEles).closest('.ui-input').find('.ui-select-btn').attr('aria-selected','false');
        $(targetEles).closest('.ui-input').find('.select-txt-wrap').removeAttr('aria-hidden');
    }

    const targetButton = $(targetEles).find('.ui-select-btn');

    if(targetButton?.length < 1) targetEles[0].setAttribute('tabindex','0');

    const delay1 = new Promise((resolve) => setTimeout(resolve, 1500));

    await delay1;
    targetButton?.length ? targetButton[0]?.focus() : targetEles[0]?.focus();
    console.log(targetButton[0]);
    console.log('----------------');
    console.log(targetEles[0]);
}

/** 
 * @summary 팝업에 닫기 버튼 생성시 여러개 생성되는 버그 대응
 * @description [관련지침]   누르기 보장
 * @param $popup HTMLElement
 */
export function isPopupMakeCloseButtonOne($popup){
    const closeBtn = isA11yCreatButton();

    const isCheckFullPopup = $popup[0].classList.contains('ui-full');
    const isCheckFullPopupInCloseBtn = $popup[0].querySelector('.btn-popup-close');

    if(isCheckFullPopup && isCheckFullPopupInCloseBtn) return; //풀팝업이면서 닫기버튼 있을시 실행 안되게

    $(closeBtn).on('click', (_) => {
        $(closeBtn).closest('.ui-popup')?.trigger('click');
    });

    if($popup?.find('.popup-content')){
        $popup?.find('.popup-content').before(closeBtn);
    }
    
    if($popup?.find('.popup-header')){
        $popup?.find('.popup-header').after(closeBtn);
    }

    const closeBtns = $popup[0]?.querySelectorAll('.close-btn');

    closeBtns && closeBtns.forEach((list,idx) => {
        if(idx > 0){
            list.remove();
        }
    });
}

/** 
 * @summary trn-carousel, carousel-select-group 일때 swiper 접근성 대응
 * @param delayTime {Number}
 * @async
 */
export async function isA11yTrnCarousel(delayTime=500){
    const isNonTrnCarusel = document?.querySelector('.trn-carousel') || document?.querySelector('.carousel-select-group');
    const trnListItems = isNonTrnCarusel?.querySelectorAll('.swiper-slide');


    const config = {
        subtree: true,
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ['aria-hidden','tabindex','class'],
    };

    if(!isNonTrnCarusel) return;

    const observer = new MutationObserver(async (mutations) => {
        //const { target } = mutations[0];

        $(isNonTrnCarusel).find('[aria-live]').removeAttr('aria-live');

        Array.from(trnListItems)?.length && Array.from(trnListItems)?.forEach((list, _idx) => {
            const btnEle = list.querySelector('.btn-option');
            const btnActiveEle = list.querySelector('.btn-option.selected');
            const spanEle = list.querySelector('.txt');
            const divEle = list.querySelectorAll('.item-subject, .txt-lv05, .btn-option > *, .area-option, .area-option > *');
            list.removeAttribute('aria-label');
            list.removeAttribute('aria-hidden');
            list.removeAttribute('tabindex');

            if(btnEle){
                btnEle?.setAttribute('aria-checked','false');
                btnEle?.removeAttribute('aria-hidden');
                btnEle?.removeAttribute('tabindex');
            }

            if(btnActiveEle){
                btnActiveEle?.setAttribute('aria-checked', 'true');
            }

            if(spanEle){
                spanEle?.removeAttribute('aria-hidden');
                spanEle?.removeAttribute('tabindex');
            }


            if(divEle){
                divEle?.forEach((list) => {
                    list?.removeAttribute('aria-hidden');
                    list?.removeAttribute('tabindex');
                });
            }
        });

        $(isNonTrnCarusel).find('.swiper-notification').remove();
    });

    observer.observe(isNonTrnCarusel, config);
}

/** 
 * @summary 콤보타입 (.ui-formBox) : 두번째 인풋으로 포커스 이동 되도록하는 함수 
 * @description [관련지침]   논리적 초점 이동
 * @param $el {HtmlSeletor}
 * @param $target {HtmlSeletor}
 * @async
 */
export async function isA11ySelectInputCombo($el, $target){
    const targetEles = $($target).parent();
     // A11YTASK-190 : 접근성대응(2025-03-04)
    // const btnTitle1 = $(targetEles).find('.select-txt-wrap .txt-name').text();
    // const btnTitle2 = $(targetEles).find('.select-txt-wrap .txt-value01').text();
    // const btnTitleVal = btnTitle1 + btnTitle2;


    //셀렉트 버튼 접근성 추가 대응(PopupSelect.js - a11yPopupInit)
    if($(targetEles).closest('.ui-input').hasClass('done')){
        $(targetEles).closest('.ui-input').find('.ui-select-btn').children().removeAttr('aria-hidden');
        if($(targetEles).closest('.ui-input').find('.ui-select-btn').text()?.length){
            // $(targetEles).find('.ui-select-btn').attr('aria-selected','true'); //A11YTASK-636 : 접근성대응(2025-06-18)
            $(targetEles).find('.select-txt-wrap').removeAttr('aria-hidden');
            // $(targetEles).find('.ui-select-btn').attr('title', btnTitleVal + ' 선택됨'); // A11YTASK-190 : 접근성대응(2025-03-04)
            // $(targetEles).find('.ui-select-btn').attr('title', '선택됨'); // A11YTASK-190 : 접근성대응(2025-03-04)
        }
    }else{
        $(targetEles).closest('.ui-input').find('.ui-select-btn').children().attr('aria-hidden', 'true');
        // $(targetEles).closest('.ui-input').find('.ui-select-btn').attr('aria-selected','false'); //A11YTASK-636 : 접근성대응(2025-06-18)
        $(targetEles).closest('.ui-input').find('.select-txt-wrap').removeAttr('aria-hidden');
    }

    let count = 0;
    let interval = setInterval(() => {

        if(count >= 25){
            $el.focus();
            clearInterval(interval);
        }

        count++;
    },100);
}

/** 
 * @summary radiogroup 접근성 대응
 * @description [관련지침]   적절한 대체텍스트의 제공
 * @param $el {HtmlSeletor}
 */
export function isA11yRadioGroup($el){
    //
    if($el){
        const defaultBtnSelectedEles = $el[0].querySelectorAll('.btn-option , .btn-trn-option');

        const isCheckShareIcon = $el.find('.ico-share-msg')?.length;
        if(isCheckShareIcon) {
            $el.find('.btn-option , .btn-trn-option').removeAttr('aria-checked');
            return;
        }
    
        defaultBtnSelectedEles?.length && Array.from(defaultBtnSelectedEles)?.forEach((list) => {
            list.parentElement.parentElement.setAttribute('role','radiogroup');
        });
    
        defaultBtnSelectedEles && isA11ySetAttr(Array.from(defaultBtnSelectedEles), 'aria-checked', 'false');
        defaultBtnSelectedEles && isA11ySetAttr(Array.from(defaultBtnSelectedEles), 'role', 'radio');
    }
}

/** 
 * @summary 현재 미사용
 */
export function isA11yPopupBlur(){
    //
    $('*').blur();
}

/** 
 * @summary 실행함수 맨마지막 로직만 실행되게하는함수(유틸함수)
 * @param func {HtmlSeletor}
 * @param timeout {Number}
 */
export function a11yDebounce(func, timeout=800){
    let timer;

    return (...args) => {
        clearTimeout(timer);
        
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    }
}

/** 
 * @summary 처음실행된 로직만 실행되고 이후 들어오는 로직 막기(유틸함수)
 * @param func {HtmlSeletor}
 * @param timeout {Number}
 */
export function a11yDebounceLeading(func, timeout=800){
    let timer;

    return (...args) => {
        if(!timer){
            func.apply(this, args);
        }
        clearTimeout(timer);
        timer = setTimeout(() => {
            timer = undefined;
        }, timeout);
    }
}

/** 
 * @summary 위젯, 팝업 셀렉트 focus이동 및 hidetext 접근성 수정
 * @description [관련지침]   초점의 논리적 이동
 * @param $content 선택자
 * @param isClose {Boolean}
 * @async
 */
export async function a11yAcessFocus($content=document, isClose=false){
    

    $('#setAlarmDateSpinner')?.data('ui')?.initFn(); //개발 vue initFn 재실행 value값 강제 동기화.

    const delay = new Promise((resolve) => setTimeout(resolve, 500));

    await delay;
    
    $('.content-mmk').removeAttr('aria-hidden');

    isA11yCarouselSelect(document, 1500);

    try {
       //스크롤 영역 없을시
        let isFocusEles = $content?.querySelectorAll('.header-content a,.header-content  button:not(.close-btn),.header-content  input, textarea,.header-content  select');
        let topHeaderTitle = ($content?.querySelector('.header-content .tit-head > *:first-child:not(.hide-txt)')?.textContent?.length || $content?.querySelector('.header-content  .tit-header > *:first-child:not(.hide-txt)')?.textContent?.length) ? ($content?.querySelector('.header-content .tit-head > *:first-child:not(.hide-txt)') || $content?.querySelector('.header-content  .tit-header > *:first-child:not(.hide-txt)')) : undefined;
        let headerTitle = $content?.querySelector('.header-content .title-field-popup:not(strong)');
        let prodnameTitle = $content?.querySelector('.header-content .prodname-tit-field');
        let leftTitle = $content?.querySelector('.header-content .home-tit') || $content?.querySelector('.header-content .tit-head');
        let divTitle = $content?.querySelector('.header-content .title-field-popup:not(strong)') || $content?.querySelector('.component-text-icon .tit');
        let contentTxt = $($content)?.find('.popup-header .title-group > .title-field-01')[0] || $content?.querySelector('.popup-header .tit-head > span:not(.hide-txt)') ||($($content)?.find('.tit-header > span:not(.hide-txt)')[0]?.length ? $($content)?.find('.tit-header > span:not(.hide-txt)')[0] : undefined);
        let depositTxt = $content?.querySelector('.section-deposit .title-field-page') || $content?.querySelector('.text-icon-group .tit:first-child') || $content?.querySelector('.popup-header .title-field-popup');
        
        let titleField21 = $content?.querySelector('.title-group .title-field-21');

        let textField = $content?.querySelector('.component-text .title-field-page');

        let activePopup = $content;

        let focusNum = 0;

        let tabindexNum = '-1';

        if($content?.querySelector('.header-group .header-content') && !$content?.querySelector('.header-group .header-content')?.textContent?.length){
            $content?.querySelector('.component-header')?.setAttribute('aria-hidden','true')
        }

        if($($content)?.find('.tit-head')[0] && $($content)?.find('.tit-head > *').hasClass('hide-txt')){
            //span내부 빈텍스트 존재 대응
            topHeaderTitle = undefined;
        }

        if($($content)?.find('.tit-head')[0] && !$($content)?.find('.tit-head')[0]?.textContent?.length){
            $($content)?.find('.tit-head')[0]?.setAttribute('aria-hidden','true');
            topHeaderTitle = undefined;
        }

        if($($content)?.find('.tit-head > *:first-child:not(.hide-txt)')[0] && !$($content)?.find('.tit-head > *:first-child:not(.hide-txt)')[0]?.textContent?.length){
            //span내부 빈텍스트 존재 대응
            topHeaderTitle = undefined;
        }

        if($($content)?.find('.tit-header > *:first-child:not(.hide-txt)')[0] && !$($content)?.find('.tit-header > *:first-child:not(.hide-txt)')[0]?.textContent?.length){
            //span내부 빈텍스트 존재 대응
            topHeaderTitle = undefined;
        }

        if($($content)?.find('.tit-header > *:first-child:not(.hide-txt)')[0] && !$($content)?.find('.tit-header').parent().hasClass('ui-animate') && ($($content)?.find('.tit-header').css('opacity') === '0' || $($content)?.find('.tit-header > *:first-child:not(.hide-txt)').css('opacity') === '0')){
            $($content)?.find('.tit-header').attr({'aria-hidden':'true'});
            $($content)?.find('.tit-header > *:first-child:not(.hide-txt)').removeAttr('aria-hidden');
            $($content)?.find('.tit-header > *:first-child:not(.hide-txt)').removeAttr('tabindex');
            topHeaderTitle = undefined;
        }

        if(!$($content)?.find('.tit-header')[0]?.innerText?.replace(/\n|\r|\s*/g, '')?.length && !$($content)?.find('.tit-header .logo-kbankpay')[0]){
            if(!$($content)?.find('.tit-header').find('.logo-zeropay')?.length && !$($content)?.find('.tit-header').find('.logo_moneytalk')?.length){
                $($content)?.find('.tit-header').attr({'aria-hidden':'true'});
                topHeaderTitle = undefined;
            }
        }

        if(leftTitle){
            leftTitle?.setAttribute('aria-hidden','false');
            leftTitle?.setAttribute('tabindex', tabindexNum);
        }

        if(topHeaderTitle){
            topHeaderTitle?.setAttribute('aria-hidden','false');
            topHeaderTitle?.setAttribute('tabindex', tabindexNum);
        }

        if(headerTitle){
            headerTitle?.setAttribute('aria-hidden','false');
            headerTitle?.setAttribute('tabindex', tabindexNum);
        }

        if(prodnameTitle){
            prodnameTitle?.setAttribute('aria-hidden','false');
            prodnameTitle?.setAttribute('tabindex', tabindexNum);
        }

        if(divTitle){
            divTitle?.setAttribute('aria-hidden','false');
            divTitle?.setAttribute('tabindex', tabindexNum);
        }

        if(contentTxt){
            contentTxt?.setAttribute('aria-hidden','false');
            contentTxt?.setAttribute('tabindex', tabindexNum);
        }

        if(depositTxt){
            depositTxt?.setAttribute('aria-hidden','false');
            depositTxt?.setAttribute('tabindex', tabindexNum);
        }

        if(titleField21){
            titleField21?.setAttribute('aria-hidden','false');
            titleField21?.setAttribute('tabindex', tabindexNum);
        }

        if(!isFocusEles?.length){
            textField?.setAttribute('aria-hidden','false');
            textField?.setAttribute('tabindex', tabindexNum);
        }

        const backBtnEles =  Array.from(document.querySelectorAll('a'))?.filter((item) => {
            if(item.role !== 'tab') return item;
        });

        backBtnEles?.length && Array.from(backBtnEles).forEach((list) => list.setAttribute('role', 'button'));

        //팝업 스피너 닫기버튼 위치 제대로 안잡히는 현상 강제 적용
        $($content)?.find('.close-btn')
            ?.attr('style', `
            position:fixed;
            top:0;
            left:0;
            z-index:-9999;
            width:100%;
            height:calc(100% - ${$($content)?.find('.popup-group').outerHeight()}px);
        `);

        const delay1 = new Promise((resolve) => setTimeout(resolve, 1500));

        await delay1;
    
        if($($content)?.hasClass('ui-kbank-page-control') && !$($content)?.hasClass('activeSlide')){
            $($content)?.find('.tit-header > span:not(.hide-txt)').removeAttr('tabindex');
            $($content)?.find('.tit-header > span:not(.hide-txt)').removeAttr('aria-hidden');
        }

        if(isFocusEles){
            isFocusEles = Array.from([leftTitle, topHeaderTitle, headerTitle, prodnameTitle, divTitle, contentTxt, depositTxt, ...isFocusEles, titleField21, textField, activePopup])?.filter((list) => {
                const isCheckHide = list?.querySelector('i');
                const isCheckBackBtn = list?.classList.contains('btn-back');

                if(!isCheckHide && isCheckBackBtn){
                    list.setAttribute('aria-hidden','true');
                }else{
                    return list
                }
            });

            if(Popup?.closeSelectors && isClose){
                isFocusEles = [$(Popup.closeSelectors)[0]]; //선택자로 target지정
                $(Popup?.closeSelectors).attr({'tabindex':tabindexNum, 'aria-hidden':'false'});

                setTimeout(() => {
                    $(Popup?.closeSelectors)?.focus();
                    
                },500);

                setTimeout(() => {
                    Popup?.a11yClickSelectorTargetInit(); //선택자 초기화.
                },1000);
            }



            if(!isFocusEles?.length) return; //여러 혼합 형태 팝업일시 focus잃어서 팝업닫기로 focus되는현상 수정

            if(isFocusEles[focusNum]?.classList.contains('activePopup')){
                isFocusEles[focusNum]?.setAttribute('role','dialog');
                //isFocusEles[focusNum]?.setAttribute('aria-modal','true'); //aria-modal 적용시 aria-live속성의 감지를 무시하는 버그로 제거
                // pc버전이 아닐때 추가 240625
                ($('html, body').hasClass('pc')) ? isFocusEles[focusNum]?.setAttribute('tabindex','0') : isFocusEles[focusNum]?.setAttribute('tabindex','-1');
            }

            
            setTimeout(() => {
                isFocusEles[focusNum]?.focus();
            },0);

            

            if($('.activeSlide').find('.roulette_btn')?.length){
                //룰렛 일시 focus실행 막기
                return;
            }
            
            if($(document).find('.toast-wrap')?.length) {
                //toast팝업 있을시 실행 안되게
                Popup.a11yDetctClosePopup();
                
                setTimeout(() => {
                    $(document).find('.toast-wrap .toast-txt').focus();
                },500);

                return;
            }
        }
    } catch (error) {
        throw new Error(error);
    }
}

/** 위젯, 팝업 셀렉트 focus이동 및 hidetext 접근성 수정
 * @param $content 선택자
 * @async
 */
export async function a11yRoleCloseButton($content=document, time=800){
    

    const delay = new Promise((resolve) => setTimeout(resolve, time));

    await delay;

    try {

        const delay1 = new Promise((resolve) => setTimeout(resolve, 800));

        await delay1;
    

        const backBtnEles =  Array.from(document.querySelectorAll('a'))?.filter((item) => {
            if(item.role !== 'tab') return item;
        });

        backBtnEles?.length && Array.from(backBtnEles).forEach((list) => list.setAttribute('role', 'button'));
    } catch (error) {
        throw new Error(error);
    }
}

/** 
 * @summary .carousel-select-group swiper 접근성 대응
 * @param $el {Selector}
 * @param time {Number}
 * @async
 */
export async function isA11yCarouselSelect($el, time=1200){
    const delay = new Promise((resolve) => setTimeout(resolve, time));

    await delay;

    const selectWrap = $el.querySelectorAll('.carousel-select-group');

    selectWrap?.length && Array.from(selectWrap).forEach((item) => {
        const ulEle = item?.querySelector('.swiper-wrapper');
        const listEle = item?.querySelectorAll('.swiper-slide');

        ulEle && ulEle.setAttribute('role','radiogroup');
        ulEle && ulEle.removeAttribute('aria-live');
        
        listEle?.length && Array.from(listEle).forEach((list) => {
            const optionEle = list?.querySelector('.btn-option');
            const areaOptionEle = list?.querySelector('.area-option');
            const titOptionEle = list?.querySelector('.tit-option');
            const txtOptionEle = list?.querySelector('.txt-option');

            list?.removeAttribute('role');
            list?.removeAttribute('aria-hidden');
            list?.removeAttribute('tabindex');
            

            const isChecked = optionEle?.classList.contains('selected');

            const isCheckShareIcon = $(list).find('.btn-option .ico-share-msg')?.length;

            if(isCheckShareIcon){
                //const txt = $(optionEle).find('.txt').text() || '';
                //$(optionEle).attr('aria-label', txt);
                $(ulEle).removeAttr('role');
            }else{
                //A11YTASK-471 : aria-checked 제거, setAttribute title 추가 (2025.04.09) 
                // optionEle.setAttribute('aria-checked', isChecked);
                if(isChecked) {
                    optionEle.setAttribute('title','선택됨');
                } else {
                    optionEle.removeAttribute('title');
                }
            }

            optionEle?.removeAttribute('aria-hidden');
            optionEle?.removeAttribute('tabindex');

            areaOptionEle?.removeAttribute('aria-hidden');
            areaOptionEle?.removeAttribute('tabindex');

            titOptionEle?.removeAttribute('aria-hidden');
            titOptionEle?.removeAttribute('tabindex');

            txtOptionEle?.removeAttribute('aria-hidden');
            txtOptionEle?.removeAttribute('tabindex');

            $(titOptionEle).find('*').removeAttr('aria-hidden');
            $(titOptionEle).find('*').removeAttr('tabindex');

            $(txtOptionEle).find('*').removeAttr('aria-hidden');
            $(txtOptionEle).find('*').removeAttr('tabindex');

            
            if(!isCheckShareIcon){
                detectSelectItem(optionEle);
            }
        });
    });

    function detectSelectItem($el){
        const config = {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ['class'],
        };

        const observer = new MutationObserver((mutation, observer) => {
            const { target } = mutation[0];

            const isChecked = target.classList.contains('selected');

            //A11YTASK-471 : aria-checked 제거, setAttribute title 추가 (2025.04.09)
            // target.setAttribute('aria-checked', isChecked);
            if(isChecked) {
                target.setAttribute('title','선택됨');
            } else {
                target.removeAttribute('title');
            }
        });

        observer.observe($el, config);
    }
}

/** 
 * @summary select-container 셀렉트 아이템 접근성 대응
 * @param $el {Selector}
 */
export function isA11ySelectGroup($el){
    // .select-container 셀렉트 아이템 접근성
    if(!$el) return;

    const selectGroupWrap = $el[0].querySelectorAll('.select-container');

    selectGroupWrap?.length && Array.from(selectGroupWrap).forEach((item) => {
        const ulEle = item?.querySelector('.select-list');
        const listEle = item?.querySelectorAll('.select-item');

        ulEle && ulEle.setAttribute('role','radiogroup');
        listEle?.length && Array.from(listEle).forEach((list) => {
            const optionEle = list?.querySelector('.btn-option ');
            
            list?.removeAttribute('role');
            if (list.closest('[data-type]')?.length > 0) { // CHPFMTASK-1714 추가
                if(list.closest('[data-type]').getAttribute('data-type') != 'select-bank') { 
                    if(optionEle){
                        const isChecked = optionEle.classList.contains('selected');
                        //A11YTASK-471 : aria-checked 제거, setAttribute title 추가 (2025.04.09)
                        // optionEle.setAttribute('aria-checked', isChecked);
                        if(isChecked) {
                            optionEle.setAttribute('title','선택됨');
                        } else {
                            optionEle.removeAttribute('title');
                        }
                        detectSelectItem(optionEle);
                    }
                }
            }
            
            // if(optionEle){
            //     const isChecked = optionEle.classList.contains('selected');

            //     optionEle.setAttribute('aria-checked', isChecked);
                
            //     detectSelectItem(optionEle);
            // }
        })
    });

    function detectSelectItem($el){
        const config = {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ['class'],
        };

        const observer = new MutationObserver((mutation, observer) => {
            const { target } = mutation[0];

            const isChecked = target.classList.contains('selected');

            
            //A11YTASK-471 : aria-checked 제거, setAttribute title 추가 (2025.04.09)
            // target.setAttribute('aria-checked', isChecked);
            if(isChecked) {
                target.setAttribute('title','선택됨');
            } else {
                target.removeAttribute('title');
            }
        });

        observer.observe($el, config);
    }
}

/** 
 * @summary 팝업 스와이퍼 촬영 케이스 접근성
 * @description [관련지침]   초점의 논리적 이동
 * @async
 */
export async function isA11ySlidesAccess(){
    // 

    if($(document).find('.toast-wrap').length) {
        //toast팝업 있을시 실행 안되게
        setTimeout(() => {
            $(document).find('.toast-wrap .toast-txt').focus();
        },300);

        return;
    }

    const delay = new Promise((resolve) => setTimeout(resolve, 2500));

    await delay;

    if($('.activePopup')?.find('.ui-input textarea.ui-text-del')?.length){//textarea자동으로 focus가는 로직 놔두기
        return;
    }
    
    
    //스와이프 접근성 포커스 막기 예외 케이스 aria-hidden, tabindex 제거 로직
    const activeWrapEle = document?.querySelectorAll('.swiper-slide-active');
    const activeGuidEle = document?.querySelectorAll('.swiper-slide-active .document-guide-group');
    const activeGuidImgEle = document?.querySelectorAll('.swiper-slide-active .guide-img');
    const activeGuidTextEle = document?.querySelectorAll('.swiper-slide-active .guide-txt');
    const activeFoodAlarmEle = document?.querySelectorAll('.swiper-slide-active .food-alarm-box, .swiper-slide-active .food-alarm-box  *');

    if(activeWrapEle){
        activeWrapEle?.length && activeWrapEle?.forEach((list) => {
            list?.removeAttribute('aria-hidden');
            list?.removeAttribute('tabindex');
        });
    }

    if(activeGuidEle){
        activeGuidEle?.length && activeGuidEle?.forEach((list) => {
            list?.removeAttribute('aria-hidden');
            list?.removeAttribute('tabindex');
        });
    }

    if(activeGuidImgEle){
        activeGuidImgEle?.length && activeGuidImgEle?.forEach((list) => {
            list?.removeAttribute('aria-hidden');
            list?.removeAttribute('tabindex');
        });
    }

    if(activeGuidTextEle){
        activeGuidTextEle?.length && activeGuidTextEle?.forEach((list) => {
            list?.removeAttribute('aria-hidden');
            list?.removeAttribute('tabindex');
        });
    }

    if(activeFoodAlarmEle){
        activeFoodAlarmEle?.length && activeFoodAlarmEle?.forEach((list) => {
            list?.removeAttribute('aria-hidden');
            list?.removeAttribute('tabindex');
        });
    }
}

/** 
 * @summary 스와이프 형태 셀렉트 예외케이스 접근성 대응
 * @description [관련지침]   초점의 논리적 이동
 * @param $el {Selector}
 */
export function isA11ySwiperSelect(el){
    if(!el) return;

    if($(el).find('.btn-option .tit-area')?.length){
        $(el).find('.btn-option .tit-area').removeAttr('aria-hidden');
        $(el).find('.btn-option .tit-area').removeAttr('tabindex');

        $(el).find('.btn-option .tit-area *').removeAttr('aria-hidden');
        $(el).find('.btn-option .tit-area *').removeAttr('tabindex');
    }
}

/** 
 * @summary 위젯, 팝업 셀렉트 focus이동 및 hidetext 접근성 수정
 * 팝업 닫기 버튼 접근성 대응을 위한 생성자 함수
 * 생성자 함수 접근성 & focus
 * @description [관련지침]   초점의 논리적 이동
 * @param containerDomNode {Selector}
 * @param sourceDomNode {Selector}
 * @param initialFocusDomNode {Selector}
 * @param firstFocusAble {Selector}
 * @param lastFocusAble {Selector}
 * @param useFocus {Boolean}
*/
export function FocusTrap({containerDomNode, sourceDomNode, initialFocusDomNode, firstFocusAble, lastFocusAble, useFocus=true} = {}){
    if(!containerDomNode){
        throw new Error('No containerDomNode provided');
    }

    if(!sourceDomNode && sourceDomNode !== null){
        throw new Error('No sourceDomNode provided');
    }

    const that = this;

    this.containerDomNode = getDomNode(containerDomNode); //해당 Nodes기준으로 부터 형제/부모영역 막기
    this.sourceDomNode = getDomNode(sourceDomNode); //팝업 닫혔을때 포커스 보낼곳
    this.initialFocusDomNode = getDomNode(initialFocusDomNode) || containerDomNode; //팝업 열렸을때 포커스 보낼곳
    this.hiddenDomNodes = []; //숨겨질 Nodes
    this.nodeAttrs = []; //숨겨진 node 접근성 속성 저장
    this.firstFocusAble = getDomNode(firstFocusAble); //첫번째 포커스 가능 Nodes
    this.lastFocusAble = getDomNode(lastFocusAble); //마지막 포커스 가능 Nodes
    this.useFocus = useFocus; //pc포커스이벤트 사용여부 default true
    
    this.activate = function(){
        that.hideOutsideDomNodes();
        that.setInitialFocus();
        if(useFocus){
            that.focusEvent();
        }
    }

    this.deactive = function(){
        that.showOutsideDomNodes();
        that.setFocusBackToSourceDomNode();
        if(useFocus){
            that.focusOffEvent();
        }
    }

    this.setInitialFocus = function(){
        that.initialFocusDomNode && that.initialFocusDomNode?.focus();
    }

    this.setFocusBackToSourceDomNode = function(){
        that.sourceDomNode && that.sourceDomNode?.focus();
    }

    this.gatherOutsideDomNode = function(currentElement){
        if(!currentElement) return undefined;

        if(currentElement !== document.querySelector('body')){
            const parentElement = currentElement.parentElement;
            const siblingElements = [...parentElement.children];
            siblingElements.forEach(function(element) {
                if(
                    element !== currentElement 
                    && 
                    !element !== currentElement
                    &&
                    !element.getAttribute('aria-live') //live속성 안읽히는 현상 방지
                ){
                    that.hiddenDomNodes.push(element);//FETASK-접근성-v1.86 : 문법수정
                    that.nodeAttrs.push({'ariaHidden': element.getAttribute('aria-hidden'), 'tabIndex': element.getAttribute('tabindex')})
                }
            });

            that.gatherOutsideDomNode(parentElement);
        }
    }

    this.hideOutsideDomNodes = function(){
        that.gatherOutsideDomNode(that.containerDomNode);

        that.hiddenDomNodes.forEach(element => {
            element.setAttribute('aria-hidden', 'true');
            element.setAttribute('tabindex', '-1');

            //관리자페이지 팝업 밑으로 내려가는현상 대응
            if(($('html')?.hasClass('pc') || $('html')?.hasClass('pc_m')) && !!$('.prd-detail-wrap')?.length){
                $(element).find('*').attr({'aria-hidden':'true', 'tabindex':'-1'});
            }
        });
    }

    this.showOutsideDomNodes = function(){
        that.hiddenDomNodes.forEach((element, idx) => {
            element.removeAttribute('aria-hidden');
            element.removeAttribute('tabindex');

            if(that.nodeAttrs[idx]['ariaHidden'] !== null){
                element.setAttribute('aria-hidden', that.nodeAttrs[idx]['ariaHidden']);
            }else{
                element.removeAttribute('aria-hidden');

                //관리자페이지 팝업 밑으로 내려가는현상 대응
                if(($('html')?.hasClass('pc') || $('html')?.hasClass('pc_m')) && !!$('.prd-detail-wrap')?.length){
                    $(element).find('*').removeAttr('aria-hidden');
                    $(element).find('*').removeAttr('tabindex');
                }
                
            }
            
            if(that.nodeAttrs[idx]['tabIndex'] !== null){
                element.setAttribute('tabindex', that.nodeAttrs[idx]['tabIndex']);
            }else{
                element.removeAttribute('tabindex');

                //관리자페이지 팝업 밑으로 내려가는현상 대응
                if(($('html')?.hasClass('pc') || $('html')?.hasClass('pc_m')) && !!$('.prd-detail-wrap')?.length){
                    $(element).find('*').removeAttr('aria-hidden');
                    $(element).find('*').removeAttr('tabindex');
                }
                
            }
        });

        that.hiddenDomNodes = [];
    }

    this.focusEvent = function(){
        that.containerDomNode?.addEventListener('keydown', function(e){
            const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            const isShiftKey = e.shiftKey;

            if(!isTabPressed) return;

            if(isShiftKey){
                if(document.activeElement === that.firstFocusAble){
                    that.lastFocusAble.focus();
                    e.preventDefault();
                }
            }else{
                if(document.activeElement === that.lastFocusAble){
                    that.firstFocusAble.focus();
                    e.preventDefault();
                }
            }
        });
    }

    this.focusOffEvent = function(){
        that?.containerDomNode && that.containerDomNode?.removeEventListener('keydown');
    }

    function getDomNode(element){
        return typeof element === 'string' ? document.querySelector(element) : element;
    }
}

/** 
 * @summary 문자열 줄바꿈 가공 함수(유틸함수)
 * @param str {String}
 */
export function a11yTextTrimRemove(str){
    // 
    if(typeof str !== 'string') throw new Error('not string type');
    
    return str.replace(/\n|\r|\s*/g, '')
}

/** 
 * @summary 아코디언 접근성 대응
 * @description [관련지침]   적절한 대체텍스트의 제공
*/  
export function isA11yAccordion(){
    const accordionBtns = $('.card-accor-btn .ui-accordion-btn, .ui-accordion-list .ui-accordion-btn');

    accordionBtns?.each((idx, item) => {
        const closeWrap = $(item).closest('.ui-accordion-list');
    
        $(item).attr('aria-expanded', closeWrap.hasClass('open'));
    });
}

/** 
 * @summary 이벤트 배너 접근성 대응
 * @description [관련지침]   적절한 대체텍스트의 제공
*/
export function isEventBanner(){
    $(document).ready(async function(){
        const delay = new Promise((resolve) => setTimeout(resolve, 500));

        await delay;

        if(!$('.btn-home-tab1.on')?.length) return;

        if($('[data-type="banner"]')?.length && $('[data-type="banner"] .admin-popup-content')?.length){
            $('[data-type="banner"]').data('ui').a11yClickSelectorTargetInit('.btn-logo-kbank');
        }
    });
}

/** 
 * @summary 자주찾는 계좌 접근성(별표) 대응
 * @description [관련지침]   적절한 대체텍스트의 제공
*/
export function isA11yRecListItem(){
    $(document).ready(function(){
        $('.rec-list-item').each((idx, item) => {
            const likeEle = $(item).find('.rec-item-bu');

            if(likeEle?.length){
                const itemText = $(item)?.find('.rec-item-txt').text().replace(/\n|\r|\s*/g, '');

                $(likeEle)?.find('.input-checkbox > input').attr('aria-label', `${itemText}, 자주찾는계좌`);
            }
        });
    });
}

/** 
 * @summary 스크린리더 켜짐 유무 localStorage.getItem("voiceoverYn")로 체크
 * @description [관련지침]   논리적 초점이동
 * 접근성 초점이동과 개발단의 강제 초점이동 로직의 충돌을 막기위해,스크린리더기활성화시에만 접근성 로직 실행되도록 함
 * @returns Boolean
*/
export function isA11yCheckVoiceOverFocusPrevent(){
    const isCheckVoiceOver = localStorage.getItem("voiceoverYn") === 'Y'; //스크린리더 체크 여부
    
    if(!isCheckVoiceOver) return;
}

/** 
 * @summary swiper aria-hidden 접근성 추가
 * @description [관련지침]   적절한 대체텍스트의 제공
*/
export function isA11ySwiperBtnChangeAria(){
    //
    $('.swiper-wrapper').each((idx, item) => {
        if(!$(item).children()?.length){
            $(item).parent().find('.control-btn').attr('aria-hidden','true');
        }else{
            $(item).parent().find('.control-btn').attr('aria-hidden','false');
        }
    });
}

/** 
 * @summary DateSpinner 이전/다음 버튼 접근성 대응
 * @description [관련지침]   누르기 동작 보장, 적절한 대체텍스트의 제공
 * @param $target {Selector}
 * @param nextText {String}
 */
export function isDateSpinnerNextTextForceReading($target, nextText){
    $($target).parent().find('.prev__btn').attr('aria-label',`${nextText}, 이전 (감소 버튼)`);
    $($target).parent().find('.next__btn').attr('aria-label',`${nextText}, 다음 (증가 버튼)`);
}